// Extracted from Post-Its.svg; paths omit the original demonstration text.
export const OFFICIAL_POST_IT_SOURCE = Object.freeze({
    width: 1857, height: 896,
    sha256: '421C491F2621DBE2FC66C01A87C52221CF5E4AA47BC5351C03CAC545DDFA6116'
});
export const OFFICIAL_POST_IT_SLOTS = Object.freeze([
  {
    "y": 694.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1294.04 728.775H1345.17H1351.86V715.698H1364.86V659.883H1294.04V728.775Z",
      "M1355.01 718.883L1355 728.892H1358.37V730.285H1361.59V727.068H1364.85V718.883H1355.01Z",
      "M1294.03 728.889H1351.78V715.703H1364.79V659.727H1368.02V724.264H1364.81V727.248H1361.59V724.031H1364.79V718.92H1355V728.889H1358.37V732.105H1290.81V659.727H1294.03V728.889ZM1361.59 730.541H1358.37V727.324H1361.59V730.541ZM1368.02 659.725H1290.82V656.508H1368.02V659.725Z"
    ],
    "x": 1329.4499999999998
  },
  {
    "y": 546.329,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M869.035 580.775H920.174H926.861V567.698H939.857V511.883H869.035V580.775Z",
      "M930.011 570.883L929.996 580.892H933.374V582.285H936.591V579.068H939.853V570.883H930.011Z",
      "M869.032 580.889H926.778V567.703H939.787V511.727H943.023V576.264H939.806V579.248H936.589V576.031H939.787V570.92H929.995V580.889H933.372V584.105H865.814V511.727H869.032V580.889ZM936.59 582.541H933.373V579.324H936.59V582.541ZM943.023 511.725H865.815V508.508H943.023V511.725Z"
    ],
    "x": 904.4459999999999
  },
  {
    "y": 468.32899999999995,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M625.035 502.775H676.174H682.861V489.698H695.857V433.883H625.035V502.775Z",
      "M686.011 492.883L685.996 502.892H689.374V504.285H692.591V501.068H695.853V492.883H686.011Z",
      "M625.032 502.889H682.778V489.703H695.787V433.727H699.023V498.264H695.806V501.248H692.589V498.031H695.787V492.92H685.995V502.889H689.372V506.105H621.814V433.727H625.032V502.889ZM692.59 504.541H689.373V501.324H692.59V504.541ZM699.023 433.725H621.815V430.508H699.023V433.725Z"
    ],
    "x": 660.4459999999999
  },
  {
    "y": 380.32899999999995,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M610.035 414.775H661.174H667.861V401.698H680.857V345.883H610.035V414.775Z",
      "M671.011 404.883L670.996 414.892H674.374V416.285H677.591V413.068H680.853V404.883H671.011Z",
      "M610.032 414.889H667.778V401.703H680.787V345.727H684.023V410.264H680.806V413.248H677.589V410.031H680.787V404.92H670.995V414.889H674.372V418.105H606.814V345.727H610.032V414.889ZM677.59 416.541H674.373V413.324H677.59V416.541ZM684.023 345.725H606.815V342.508H684.023V345.725Z"
    ],
    "x": 645.4459999999999
  },
  {
    "y": 50.828700000000005,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1550.53 85.2746H1601.67H1608.36V72.1981H1621.36V16.3828H1550.53V85.2746Z",
      "M1611.51 75.3828L1611.49 85.3922H1614.87V86.785H1618.09V83.5679H1621.35V75.3828H1611.51Z",
      "M1550.53 85.3887H1608.28V72.2031H1621.29V16.2266H1624.52V80.7637H1621.3V83.748H1618.09V80.5312H1621.29V75.4199H1611.49V85.3887H1614.87V88.6055H1547.31V16.2266H1550.53V85.3887ZM1618.09 87.041H1614.87V83.8242H1618.09V87.041ZM1624.52 16.2246H1547.31V13.0078H1624.52V16.2246Z"
    ],
    "x": 1585.945
  },
  {
    "y": 104.38325,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1509.9 138.829H1561.04H1567.72V125.753H1580.72V69.9375H1509.9V138.829Z",
      "M1570.87 128.938L1570.86 138.947H1574.24V140.34H1577.45V137.123H1580.71V128.938H1570.87Z",
      "M1509.89 138.943H1567.64V125.758H1580.65V69.7812H1583.88V134.318H1580.67V137.303H1577.45V134.086H1580.65V128.975H1570.86V138.943H1574.23V142.16H1506.68V69.7812H1509.89V138.943ZM1577.45 140.596H1574.23V137.379H1577.45V140.596ZM1583.88 69.7793H1506.68V66.5625H1583.88V69.7793Z"
    ],
    "x": 1545.31
  },
  {
    "y": 143.7505,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1527.04 178.196H1578.18H1584.86V165.12H1597.86V109.305H1527.04V178.196Z",
      "M1588.01 168.305L1588 178.314H1591.38V179.707H1594.59V176.49H1597.85V168.305H1588.01Z",
      "M1527.03 178.311H1584.78V165.125H1597.79V109.148H1601.03V173.686H1597.81V176.67H1594.59V173.453H1597.79V168.342H1588V178.311H1591.37V181.527H1523.82V109.148H1527.03V178.311ZM1594.59 179.963H1591.38V176.746H1594.59V179.963ZM1601.03 109.146H1523.82V105.93H1601.03V109.146Z"
    ],
    "x": 1562.4499999999998
  },
  {
    "y": 155.08249999999998,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1596.58 189.528H1647.72H1654.41V176.452H1667.4V120.637H1596.58V189.528Z",
      "M1657.56 179.637L1657.54 189.646H1660.92V191.039H1664.14V187.822H1667.4V179.637H1657.56Z",
      "M1596.58 189.643H1654.33V176.457H1667.33V120.48H1670.57V185.018H1667.35V188.002H1664.14V184.785H1667.33V179.674H1657.54V189.643H1660.92V192.859H1593.36V120.48H1596.58V189.643ZM1664.14 191.295H1660.92V188.078H1664.14V191.295ZM1670.57 120.479H1593.36V117.262H1670.57V120.479Z"
    ],
    "x": 1631.99
  },
  {
    "y": 180.403,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1638.9 214.849H1690.04H1696.73V201.772H1709.73V145.957H1638.9V214.849Z",
      "M1699.88 204.957L1699.87 214.966H1703.24V216.359H1706.46V213.142H1709.72V204.957H1699.88Z",
      "M1638.9 214.963H1696.65V201.777H1709.66V145.801H1712.89V210.338H1709.67V213.322H1706.46V210.105H1709.66V204.994H1699.86V214.963H1703.24V218.18H1635.68V145.801H1638.9V214.963ZM1706.46 216.615H1703.24V213.398H1706.46V216.615ZM1712.89 145.799H1635.68V142.582H1712.89V145.799Z"
    ],
    "x": 1674.315
  },
  {
    "y": 170.403,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1557.9 204.849H1609.04H1615.73V191.772H1628.73V135.957H1557.9V204.849Z",
      "M1618.88 194.957L1618.87 204.966H1622.24V206.359H1625.46V203.142H1628.72V194.957H1618.88Z",
      "M1557.9 204.963H1615.65V191.777H1628.66V135.801H1631.89V200.338H1628.67V203.322H1625.46V200.105H1628.66V194.994H1618.86V204.963H1622.24V208.18H1554.68V135.801H1557.9V204.963ZM1625.46 206.615H1622.24V203.398H1625.46V206.615ZM1631.89 135.799H1554.68V132.582H1631.89V135.799Z"
    ],
    "x": 1593.315
  },
  {
    "y": 235.325,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1635.91 269.771H1687.05H1693.74V256.694H1706.73V200.879H1635.91V269.771Z",
      "M1696.89 259.879L1696.87 269.888H1700.25V271.281H1703.47V268.064H1706.73V259.879H1696.89Z",
      "M1635.91 269.885H1693.66V256.699H1706.66V200.723H1709.9V265.26H1706.68V268.244H1703.47V265.027H1706.66V259.916H1696.87V269.885H1700.25V273.102H1632.69V200.723H1635.91V269.885ZM1703.47 271.537H1700.25V268.32H1703.47V271.537ZM1709.9 200.721H1632.69V197.504H1709.9V200.721Z"
    ],
    "x": 1671.3200000000002
  },
  {
    "y": 283.43,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1687.36 317.876H1738.5H1745.18V304.8H1758.18V248.984H1687.36V317.876Z",
      "M1748.33 307.984L1748.32 317.994H1751.7V319.387H1754.91V316.17H1758.17V307.984H1748.33Z",
      "M1687.35 317.99H1745.1V304.805H1758.11V248.828H1761.35V313.365H1758.13V316.35H1754.91V313.133H1758.11V308.021H1748.32V317.99H1751.69V321.207H1684.14V248.828H1687.35V317.99ZM1754.91 319.643H1751.7V316.426H1754.91V319.643ZM1761.35 248.826H1684.14V245.609H1761.35V248.826Z"
    ],
    "x": 1722.77
  },
  {
    "y": 333.2155,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1725.54 367.661H1776.68H1783.37V354.585H1796.37V298.77H1725.54V367.661Z",
      "M1786.52 357.77L1786.51 367.779H1789.88V369.172H1793.1V365.955H1796.36V357.77H1786.52Z",
      "M1725.54 367.775H1783.29V354.59H1796.3V298.613H1799.53V363.15H1796.32V366.135H1793.1V362.918H1796.3V357.807H1786.5V367.775H1789.88V370.992H1722.32V298.613H1725.54V367.775ZM1793.1 369.428H1789.88V366.211H1793.1V369.428ZM1799.53 298.611H1722.33V295.395H1799.53V298.611Z"
    ],
    "x": 1760.955
  },
  {
    "y": 403.5825,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1725.41 438.028H1776.55H1783.24V424.952H1796.23V369.137H1725.41V438.028Z",
      "M1786.39 428.137L1786.37 438.146H1789.75V439.539H1792.97V436.322H1796.23V428.137H1786.39Z",
      "M1725.41 438.143H1783.15V424.957H1796.16V368.98H1799.4V433.518H1796.18V436.502H1792.96V433.285H1796.16V428.174H1786.37V438.143H1789.75V441.359H1722.19V368.98H1725.41V438.143ZM1792.96 439.795H1789.75V436.578H1792.96V439.795ZM1799.4 368.979H1722.19V365.762H1799.4V368.979Z"
    ],
    "x": 1760.8200000000002
  },
  {
    "y": 456.7075,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1753.3 491.153H1804.44H1811.13V478.077H1824.12V422.262H1753.3V491.153Z",
      "M1814.28 481.262L1814.26 491.271H1817.64V492.664H1820.86V489.447H1824.12V481.262H1814.28Z",
      "M1753.3 491.268H1811.04V478.082H1824.05V422.105H1827.29V486.643H1824.07V489.627H1820.85V486.41H1824.05V481.299H1814.26V491.268H1817.64V494.484H1750.08V422.105H1753.3V491.268ZM1820.86 492.92H1817.64V489.703H1820.86V492.92ZM1827.29 422.104H1750.08V418.887H1827.29V422.104Z"
    ],
    "x": 1788.71
  },
  {
    "y": 526.059,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1756.84 560.505H1807.98H1814.67V547.429H1827.66V491.613H1756.84V560.505Z",
      "M1817.82 550.613L1817.8 560.623H1821.18V562.015H1824.4V558.798H1827.66V550.613H1817.82Z",
      "M1756.84 560.619H1814.58V547.434H1827.59V491.457H1830.83V555.994H1827.61V558.979H1824.4V555.762H1827.59V550.65H1817.8V560.619H1821.18V563.836H1753.62V491.457H1756.84V560.619ZM1824.4 562.271H1821.18V559.055H1824.4V562.271ZM1830.83 491.455H1753.62V488.238H1830.83V491.455Z"
    ],
    "x": 1792.25
  },
  {
    "y": 580.8050000000001,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1769.31 615.251H1820.45H1827.13V602.175H1840.13V546.359H1769.31V615.251Z",
      "M1830.28 605.359L1830.27 615.369H1833.65V616.762H1836.86V613.545H1840.12V605.359H1830.28Z",
      "M1769.3 615.365H1827.05V602.18H1840.06V546.203H1843.29V610.74H1840.08V613.725H1836.86V610.508H1840.06V605.396H1830.27V615.365H1833.64V618.582H1766.09V546.203H1769.3V615.365ZM1836.86 617.018H1833.64V613.801H1836.86V617.018ZM1843.29 546.201H1766.09V542.984H1843.29V546.201Z"
    ],
    "x": 1804.72
  },
  {
    "y": 649.321,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1758.83 683.767H1809.97H1816.66V670.69H1829.65V614.875H1758.83V683.767Z",
      "M1819.81 673.875L1819.79 683.884H1823.17V685.277H1826.39V682.06H1829.65V673.875H1819.81Z",
      "M1758.83 683.881H1816.57V670.695H1829.58V614.719H1832.82V679.256H1829.6V682.24H1826.38V679.023H1829.58V673.912H1819.79V683.881H1823.17V687.098H1755.61V614.719H1758.83V683.881ZM1826.38 685.533H1823.17V682.316H1826.38V685.533ZM1832.82 614.717H1755.61V611.5H1832.82V614.717Z"
    ],
    "x": 1794.24
  },
  {
    "y": 690.7660000000001,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1707.33 725.212H1758.47H1765.15V712.136H1778.15V656.32H1707.33V725.212Z",
      "M1768.3 715.32L1768.29 725.33H1771.67V726.722H1774.88V723.505H1778.15V715.32H1768.3Z",
      "M1707.33 725.326H1765.07V712.141H1778.08V656.164H1781.32V720.701H1778.1V723.686H1774.88V720.469H1778.08V715.357H1768.29V725.326H1771.67V728.543H1704.11V656.164H1707.33V725.326ZM1774.88 726.979H1771.67V723.762H1774.88V726.979ZM1781.32 656.162H1704.11V652.945H1781.32V656.162Z"
    ],
    "x": 1742.74
  },
  {
    "y": 630.7660000000001,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1707.33 665.212H1758.47H1765.15V652.136H1778.15V596.32H1707.33V665.212Z",
      "M1768.3 655.32L1768.29 665.33H1771.67V666.722H1774.88V663.505H1778.15V655.32H1768.3Z",
      "M1707.33 665.326H1765.07V652.141H1778.08V596.164H1781.32V660.701H1778.1V663.686H1774.88V660.469H1778.08V655.357H1768.29V665.326H1771.67V668.543H1704.11V596.164H1707.33V665.326ZM1774.88 666.979H1771.67V663.762H1774.88V666.979ZM1781.32 596.162H1704.11V592.945H1781.32V596.162Z"
    ],
    "x": 1742.74
  },
  {
    "y": 703.598,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1661 738.044H1712.14H1718.82V724.968H1731.82V669.152H1661V738.044Z",
      "M1721.97 728.152L1721.96 738.162H1725.34V739.554H1728.55V736.337H1731.82V728.152H1721.97Z",
      "M1661 738.158H1718.74V724.973H1731.75V668.996H1734.99V733.533H1731.77V736.518H1728.55V733.301H1731.75V728.189H1721.96V738.158H1725.33V741.375H1657.78V668.996H1661V738.158ZM1728.55 739.811H1725.34V736.594H1728.55V739.811ZM1734.99 668.994H1657.78V665.777H1734.99V668.994Z"
    ],
    "x": 1696.4099999999999
  },
  {
    "y": 738.1255,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1323.49 772.571H1374.63H1381.32V759.495H1394.32V703.68H1323.49V772.571Z",
      "M1384.47 762.68L1384.46 772.689H1387.83V774.082H1391.05V770.865H1394.31V762.68H1384.47Z",
      "M1323.49 772.686H1381.24V759.5H1394.25V703.523H1397.48V768.061H1394.26V771.045H1391.05V767.828H1394.25V762.717H1384.45V772.686H1387.83V775.902H1320.27V703.523H1323.49V772.686ZM1391.05 774.338H1387.83V771.121H1391.05V774.338ZM1397.48 703.521H1320.27V700.305H1397.48V703.521Z"
    ],
    "x": 1358.905
  },
  {
    "y": 738.5435,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1286.8 772.989H1337.94H1344.63V759.913H1357.62V704.098H1286.8V772.989Z",
      "M1347.78 763.098L1347.76 773.107H1351.14V774.5H1354.36V771.283H1357.62V763.098H1347.78Z",
      "M1286.8 773.104H1344.54V759.918H1357.55V703.941H1360.79V768.479H1357.57V771.463H1354.35V768.246H1357.55V763.135H1347.76V773.104H1351.14V776.32H1283.58V703.941H1286.8V773.104ZM1354.36 774.756H1351.14V771.539H1354.36V774.756ZM1360.79 703.939H1283.58V700.723H1360.79V703.939Z"
    ],
    "x": 1322.21
  },
  {
    "y": 738.6685,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1216.34 773.114H1267.48H1274.16V760.038H1287.16V704.223H1216.34V773.114Z",
      "M1277.31 763.223L1277.3 773.232H1280.68V774.625H1283.89V771.408H1287.16V763.223H1277.31Z",
      "M1216.33 773.229H1274.08V760.043H1287.09V704.066H1290.33V768.604H1287.11V771.588H1283.89V768.371H1287.09V763.26H1277.3V773.229H1280.67V776.445H1213.12V704.066H1216.33V773.229ZM1283.89 774.881H1280.68V771.664H1283.89V774.881ZM1290.33 704.064H1213.12V700.848H1290.33V704.064Z"
    ],
    "x": 1251.75
  },
  {
    "y": 738.8325,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1145.87 773.278H1197.01H1203.7V760.202H1216.7V704.387H1145.87V773.278Z",
      "M1206.85 763.387L1206.83 773.396H1210.21V774.789H1213.43V771.572H1216.69V763.387H1206.85Z",
      "M1145.87 773.393H1203.62V760.207H1216.62V704.23H1219.86V768.768H1216.64V771.752H1213.43V768.535H1216.62V763.424H1206.83V773.393H1210.21V776.609H1142.65V704.23H1145.87V773.393ZM1213.43 775.045H1210.21V771.828H1213.43V775.045ZM1219.86 704.229H1142.65V701.012H1219.86V704.229Z"
    ],
    "x": 1181.2849999999999
  },
  {
    "y": 739.0905,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1075.41 773.536H1126.55H1133.24V760.46H1146.23V704.645H1075.41V773.536Z",
      "M1136.39 763.645L1136.37 773.654H1139.75V775.047H1142.97V771.83H1146.23V763.645H1136.39Z",
      "M1075.41 773.65H1133.15V760.465H1146.16V704.488H1149.4V769.025H1146.18V772.01H1142.96V768.793H1146.16V763.682H1136.37V773.65H1139.75V776.867H1072.19V704.488H1075.41V773.65ZM1142.96 775.303H1139.75V772.086H1142.96V775.303ZM1149.4 704.486H1072.19V701.27H1149.4V704.486Z"
    ],
    "x": 1110.8200000000002
  },
  {
    "y": 739.348,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1004.95 773.794H1056.09H1062.77V760.718H1075.77V704.902H1004.95V773.794Z",
      "M1065.92 763.902L1065.91 773.912H1069.29V775.304H1072.5V772.087H1075.76V763.902H1065.92Z",
      "M1004.94 773.908H1062.69V760.723H1075.7V704.746H1078.94V769.283H1075.72V772.268H1072.5V769.051H1075.7V763.939H1065.91V773.908H1069.28V777.125H1001.73V704.746H1004.94V773.908ZM1072.5 775.561H1069.29V772.344H1072.5V775.561ZM1078.94 704.744H1001.73V701.527H1078.94V704.744Z"
    ],
    "x": 1040.3600000000001
  },
  {
    "y": 739.61,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M934.484 774.056H985.623H992.31V760.979H1005.31V705.164H934.484V774.056Z",
      "M995.46 764.164L995.445 774.173H998.823V775.566H1002.04V772.349H1005.3V764.164H995.46Z",
      "M934.481 774.17H992.228V760.984H1005.24V705.008H1008.47V769.545H1005.25V772.529H1002.04V769.312H1005.24V764.201H995.444V774.17H998.821V777.387H931.264V705.008H934.481V774.17ZM1002.04 775.822H998.822V772.605H1002.04V775.822ZM1008.47 705.006H931.265V701.789H1008.47V705.006Z"
    ],
    "x": 969.8969999999999
  },
  {
    "y": 739.895,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M864.021 774.341H915.16H921.847V761.265H934.843V705.449H864.021V774.341Z",
      "M924.997 764.449L924.982 774.459H928.36V775.851H931.577V772.634H934.839V764.449H924.997Z",
      "M864.019 774.455H921.765V761.27H934.773V705.293H938.01V769.83H934.792V772.814H931.575V769.598H934.773V764.486H924.981V774.455H928.358V777.672H860.801V705.293H864.019V774.455ZM931.576 776.107H928.359V772.891H931.576V776.107ZM938.01 705.291H860.802V702.074H938.01V705.291Z"
    ],
    "x": 899.432
  },
  {
    "y": 740.2975,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M793.561 774.743H844.699H851.386V761.667H864.383V705.852H793.561V774.743Z",
      "M854.536 764.852L854.521 774.861H857.899V776.254H861.116V773.037H864.378V764.852H854.536Z",
      "M793.558 774.857H851.304V761.672H864.312V705.695H867.549V770.232H864.331V773.217H861.114V770H864.312V764.889H854.521V774.857H857.897V778.074H790.34V705.695H793.558V774.857ZM861.115 776.51H857.898V773.293H861.115V776.51ZM867.549 705.693H790.341V702.477H867.549V705.693Z"
    ],
    "x": 828.972
  },
  {
    "y": 740.696,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M723.098 775.142H774.236H780.924V762.065H793.92V706.25H723.098V775.142Z",
      "M784.073 765.25L784.059 775.259H787.436V776.652H790.653V773.435H793.915V765.25H784.073Z",
      "M723.095 775.256H780.841V762.07H793.85V706.094H797.086V770.631H793.868V773.615H790.651V770.398H793.85V765.287H784.058V775.256H787.435V778.473H719.877V706.094H723.095V775.256ZM790.652 776.908H787.436V773.691H790.652V776.908ZM797.086 706.092H719.878V702.875H797.086V706.092Z"
    ],
    "x": 758.509
  },
  {
    "y": 741.235,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M652.637 775.681H703.775H710.463V762.604H723.459V706.789H652.637V775.681Z",
      "M713.613 765.789L713.598 775.798H716.976V777.191H720.193V773.974H723.454V765.789H713.613Z",
      "M652.634 775.795H710.38V762.609H723.389V706.633H726.625V771.17H723.407V774.154H720.19V770.938H723.389V765.826H713.597V775.795H716.974V779.012H649.416V706.633H652.634V775.795ZM720.191 777.447H716.975V774.23H720.191V777.447ZM726.625 706.631H649.417V703.414H726.625V706.631Z"
    ],
    "x": 688.048
  },
  {
    "y": 739.696,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M582.324 774.142H633.463H640.15V761.065H653.146V705.25H582.324V774.142Z",
      "M643.3 764.25L643.285 774.259H646.663V775.652H649.88V772.435H653.142V764.25H643.3Z",
      "M582.321 774.256H640.067V761.07H653.076V705.094H656.312V769.631H653.095V772.615H649.878V769.398H653.076V764.287H643.284V774.256H646.661V777.473H579.104V705.094H582.321V774.256ZM649.879 775.908H646.662V772.691H649.879V775.908ZM656.312 705.092H579.104V701.875H656.312V705.092Z"
    ],
    "x": 617.7349999999999
  },
  {
    "y": 729.7075,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M514.928 764.153H566.066H572.754V751.077H585.75V695.262H514.928V764.153Z",
      "M575.904 754.262L575.889 764.271H579.267V765.664H582.484V762.447H585.745V754.262H575.904Z",
      "M514.925 764.268H572.671V751.082H585.68V695.105H588.916V759.643H585.698V762.627H582.481V759.41H585.68V754.299H575.888V764.268H579.265V767.484H511.707V695.105H514.925V764.268ZM582.482 765.92H579.266V762.703H582.482V765.92ZM588.916 695.104H511.708V691.887H588.916V695.104Z"
    ],
    "x": 550.3389999999999
  },
  {
    "y": 726.915,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M149.566 761.361H200.705H207.392V748.284H220.388V692.469H149.566V761.361Z",
      "M210.542 751.469L210.527 761.478H213.905V762.871H217.122V759.654H220.384V751.469H210.542Z",
      "M149.563 761.475H207.31V748.289H220.318V692.312H223.555V756.85H220.337V759.834H217.12V756.617H220.318V751.506H210.526V761.475H213.903V764.691H146.346V692.312H149.563V761.475ZM217.121 763.127H213.904V759.91H217.121V763.127ZM223.555 692.311H146.347V689.094H223.555V692.311Z"
    ],
    "x": 184.977
  },
  {
    "y": 716.719,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M79.9492 751.165H131.088H137.775V738.089H150.771V682.273H79.9492V751.165Z",
      "M140.925 741.273L140.91 751.283H144.288V752.676H147.505V749.459H150.767V741.273H140.925Z",
      "M79.9463 751.279H137.692V738.094H150.701V682.117H153.938V746.654H150.72V749.639H147.503V746.422H150.701V741.311H140.909V751.279H144.286V754.496H76.7285V682.117H79.9463V751.279ZM147.504 752.932H144.287V749.715H147.504V752.932ZM153.938 682.115H76.7295V678.898H153.938V682.115Z"
    ],
    "x": 115.36009999999999
  },
  {
    "y": 686.86,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M19.0684 721.306H70.207H76.8943V708.229H89.8903V652.414H19.0684V721.306Z",
      "M80.0441 711.414L80.0293 721.423H83.4072V722.816H86.6242V719.599H89.8858V711.414H80.0441Z",
      "M19.0654 721.42H76.8115V708.234H89.8203V652.258H93.0566V716.795H89.8389V719.779H86.6221V716.562H89.8203V711.451H80.0283V721.42H83.4053V724.637H15.8477V652.258H19.0654V721.42ZM86.623 723.072H83.4062V719.855H86.623V723.072ZM93.0566 652.256H15.8486V649.039H93.0566V652.256Z"
    ],
    "x": 54.47935
  },
  {
    "y": 621.3405,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M21.5957 655.786H72.7343H79.4216V642.71H92.4177V586.895H21.5957V655.786Z",
      "M82.5715 645.895L82.5566 655.904H85.9345V657.297H89.1515V654.08H92.4132V645.895H82.5715Z",
      "M21.5928 655.9H79.3389V642.715H92.3477V586.738H95.584V651.275H92.3662V654.26H89.1494V651.043H92.3477V645.932H82.5557V655.9H85.9326V659.117H18.375V586.738H21.5928V655.9ZM89.1504 657.553H85.9336V654.336H89.1504V657.553ZM95.584 586.736H18.376V583.52H95.584V586.736Z"
    ],
    "x": 57.006699999999995
  },
  {
    "y": 551.813,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M16.4199 586.259H67.5585H74.2458V573.182H87.2419V517.367H16.4199V586.259Z",
      "M77.3957 576.367L77.3809 586.377H80.7587V587.769H83.9757V584.552H87.2374V576.367H77.3957Z",
      "M16.417 586.373H74.1631V573.188H87.1719V517.211H90.4082V581.748H87.1904V584.732H83.9736V581.516H87.1719V576.404H77.3799V586.373H80.7568V589.59H13.1992V517.211H16.417V586.373ZM83.9746 588.025H80.7578V584.809H83.9746V588.025ZM90.4082 517.209H13.2002V513.992H90.4082V517.209Z"
    ],
    "x": 51.8309
  },
  {
    "y": 497.606,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M50.3477 532.052H101.486H108.174V518.975H121.17V463.16H50.3477V532.052Z",
      "M111.323 522.16L111.309 532.17H114.686V533.562H117.903V530.345H121.165V522.16H111.323Z",
      "M50.3447 532.166H108.091V518.98H121.1V463.004H124.336V527.541H121.118V530.525H117.901V527.309H121.1V522.197H111.308V532.166H114.685V535.383H47.127V463.004H50.3447V532.166ZM117.902 533.818H114.686V530.602H117.902V533.818ZM124.336 463.002H47.1279V459.785H124.336V463.002Z"
    ],
    "x": 85.75885
  },
  {
    "y": 433.11400000000003,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M51.9824 467.56H103.121H109.808V454.483H122.804V398.668H51.9824V467.56Z",
      "M112.958 457.668L112.943 467.677H116.321V469.07H119.538V465.853H122.8V457.668H112.958Z",
      "M51.9795 467.674H109.726V454.488H122.734V398.512H125.971V463.049H122.753V466.033H119.536V462.816H122.734V457.705H112.942V467.674H116.319V470.891H48.7617V398.512H51.9795V467.674ZM119.537 469.326H116.32V466.109H119.537V469.326ZM125.971 398.51H48.7627V395.293H125.971V398.51Z"
    ],
    "x": 87.39320000000001
  },
  {
    "y": 389.6335,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M99.9336 424.079H151.072H157.76V411.003H170.756V355.188H99.9336V424.079Z",
      "M160.909 414.188L160.895 424.197H164.272V425.59H167.489V422.373H170.751V414.188H160.909Z",
      "M99.9307 424.193H157.677V411.008H170.686V355.031H173.922V419.568H170.704V422.553H167.487V419.336H170.686V414.225H160.894V424.193H164.271V427.41H96.7129V355.031H99.9307V424.193ZM167.488 425.846H164.271V422.629H167.488V425.846ZM173.922 355.029H96.7139V351.812H173.922V355.029Z"
    ],
    "x": 135.3448
  },
  {
    "y": 370.7545,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M167.684 405.2H218.822H225.51V392.124H238.506V336.309H167.684V405.2Z",
      "M228.659 395.309L228.645 405.318H232.022V406.711H235.239V403.494H238.501V395.309H228.659Z",
      "M167.681 405.314H225.427V392.129H238.436V336.152H241.672V400.689H238.454V403.674H235.237V400.457H238.436V395.346H228.644V405.314H232.021V408.531H164.463V336.152H167.681V405.314ZM235.238 406.967H232.021V403.75H235.238V406.967ZM241.672 336.15H164.464V332.934H241.672V336.15Z"
    ],
    "x": 203.095
  },
  {
    "y": 360.477,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M237.381 394.923H288.519H295.207V381.847H308.203V326.031H237.381V394.923Z",
      "M298.357 385.031L298.342 395.041H301.72V396.433H304.937V393.216H308.198V385.031H298.357Z",
      "M237.378 395.037H295.124V381.852H308.133V325.875H311.369V390.412H308.151V393.396H304.935V390.18H308.133V385.068H298.341V395.037H301.718V398.254H234.16V325.875H237.378V395.037ZM304.936 396.689H301.719V393.473H304.936V396.689ZM311.369 325.873H234.161V322.656H311.369V325.873Z"
    ],
    "x": 272.792
  },
  {
    "y": 352.01599999999996,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M307.334 386.462H358.473H365.16V373.386H378.156V317.57H307.334V386.462Z",
      "M368.31 376.57L368.295 386.58H371.673V387.972H374.89V384.755H378.151V376.57H368.31Z",
      "M307.331 386.576H365.077V373.391H378.086V317.414H381.322V381.951H378.104V384.936H374.888V381.719H378.086V376.607H368.294V386.576H371.671V389.793H304.113V317.414H307.331V386.576ZM374.889 388.229H371.672V385.012H374.889V388.229ZM381.322 317.412H304.114V314.195H381.322V317.412Z"
    ],
    "x": 342.745
  },
  {
    "y": 343.59799999999996,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M377.293 378.044H428.432H435.119V364.968H448.115V309.152H377.293V378.044Z",
      "M438.269 368.152L438.254 378.162H441.632V379.554H444.849V376.337H448.11V368.152H438.269Z",
      "M377.29 378.158H435.036V364.973H448.045V308.996H451.281V373.533H448.063V376.518H444.847V373.301H448.045V368.189H438.253V378.158H441.63V381.375H374.072V308.996H377.29V378.158ZM444.848 379.811H441.631V376.594H444.848V379.811ZM451.281 308.994H374.073V305.777H451.281V308.994Z"
    ],
    "x": 412.704
  },
  {
    "y": 336.3795,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M447.375 370.825H498.514H505.201V357.749H518.197V301.934H447.375V370.825Z",
      "M508.351 360.934L508.336 370.943H511.714V372.336H514.931V369.119H518.192V360.934H508.351Z",
      "M447.372 370.939H505.118V357.754H518.127V301.777H521.363V366.314H518.146V369.299H514.929V366.082H518.127V360.971H508.335V370.939H511.712V374.156H444.154V301.777H447.372V370.939ZM514.93 372.592H511.713V369.375H514.93V372.592ZM521.363 301.775H444.155V298.559H521.363V301.775Z"
    ],
    "x": 482.786
  },
  {
    "y": 324.774,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M514.357 359.22H565.496H572.183V346.143H585.179V290.328H514.357V359.22Z",
      "M575.333 349.328L575.318 359.338H578.696V360.73H581.913V357.513H585.175V349.328H575.333Z",
      "M514.354 359.334H572.101V346.148H585.109V290.172H588.346V354.709H585.128V357.693H581.911V354.477H585.109V349.365H575.317V359.334H578.694V362.551H511.137V290.172H514.354V359.334ZM581.912 360.986H578.695V357.77H581.912V360.986ZM588.346 290.17H511.138V286.953H588.346V290.17Z"
    ],
    "x": 549.768
  },
  {
    "y": 286.4575,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M573.492 320.903H624.631H631.318V307.827H644.314V252.012H573.492V320.903Z",
      "M634.468 311.012L634.453 321.021H637.831V322.414H641.048V319.197H644.31V311.012H634.468Z",
      "M573.489 321.018H631.235V307.832H644.244V251.855H647.48V316.393H644.263V319.377H641.046V316.16H644.244V311.049H634.452V321.018H637.829V324.234H570.271V251.855H573.489V321.018ZM641.047 322.67H637.83V319.453H641.047V322.67ZM647.48 251.854H570.272V248.637H647.48V251.854Z"
    ],
    "x": 608.903
  },
  {
    "y": 248.551,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M632.891 282.997H684.029H690.717V269.921H703.713V214.105H632.891V282.997Z",
      "M693.866 273.105L693.852 283.115H697.229V284.508H700.446V281.291H703.708V273.105H693.866Z",
      "M632.888 283.111H690.634V269.926H703.643V213.949H706.879V278.486H703.661V281.471H700.444V278.254H703.643V273.143H693.851V283.111H697.228V286.328H629.67V213.949H632.888V283.111ZM700.445 284.764H697.229V281.547H700.445V284.764ZM706.879 213.947H629.671V210.73H706.879V213.947Z"
    ],
    "x": 668.3019999999999
  },
  {
    "y": 212.0005,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M693.131 246.446H744.269H750.957V233.37H763.953V177.555H693.131V246.446Z",
      "M754.107 236.555L754.092 246.564H757.47V247.957H760.687V244.74H763.948V236.555H754.107Z",
      "M693.128 246.561H750.874V233.375H763.883V177.398H767.119V241.936H763.901V244.92H760.685V241.703H763.883V236.592H754.091V246.561H757.468V249.777H689.91V177.398H693.128V246.561ZM760.686 248.213H757.469V244.996H760.686V248.213ZM767.119 177.396H689.911V174.18H767.119V177.396Z"
    ],
    "x": 728.5419999999999
  },
  {
    "y": 176.653,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M754.076 211.099H805.215H811.902V198.022H824.898V142.207H754.076V211.099Z",
      "M815.052 201.207L815.037 211.216H818.415V212.609H821.632V209.392H824.894V201.207H815.052Z",
      "M754.073 211.213H811.819V198.027H824.828V142.051H828.064V206.588H824.847V209.572H821.63V206.355H824.828V201.244H815.036V211.213H818.413V214.43H750.855V142.051H754.073V211.213ZM821.631 212.865H818.414V209.648H821.631V212.865ZM828.064 142.049H750.856V138.832H828.064V142.049Z"
    ],
    "x": 789.4870000000001
  },
  {
    "y": 149.247,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M818.818 183.693H869.957H876.644V170.616H889.64V114.801H818.818V183.693Z",
      "M879.794 173.801L879.779 183.81H883.157V185.203H886.374V181.986H889.636V173.801H879.794Z",
      "M818.815 183.807H876.562V170.621H889.57V114.645H892.807V179.182H889.589V182.166H886.372V178.949H889.57V173.838H879.778V183.807H883.155V187.023H815.598V114.645H818.815V183.807ZM886.373 185.459H883.156V182.242H886.373V185.459ZM892.807 114.643H815.599V111.426H892.807V114.643Z"
    ],
    "x": 854.229
  },
  {
    "y": 131.76614999999998,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M886.855 166.212H937.994H944.681V153.136H957.677V97.3203H886.855V166.212Z",
      "M947.831 156.32L947.816 166.33H951.194V167.722H954.411V164.505H957.673V156.32H947.831Z",
      "M886.853 166.326H944.599V153.141H957.607V97.1641H960.844V161.701H957.626V164.686H954.409V161.469H957.607V156.357H947.815V166.326H951.192V169.543H883.635V97.1641H886.853V166.326ZM954.41 167.979H951.193V164.762H954.41V167.979ZM960.844 97.1621H883.636V93.9453H960.844V97.1621Z"
    ],
    "x": 922.2660000000001
  },
  {
    "y": 109.5942,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M952.119 144.04H1003.26H1009.95V130.964H1022.94V75.1484H952.119V144.04Z",
      "M1013.09 134.148L1013.08 144.158H1016.46V145.551H1019.67V142.334H1022.94V134.148H1013.09Z",
      "M952.116 144.154H1009.86V130.969H1022.87V74.9922H1026.11V139.529H1022.89V142.514H1019.67V139.297H1022.87V134.186H1013.08V144.154H1016.46V147.371H948.898V74.9922H952.116V144.154ZM1019.67 145.807H1016.46V142.59H1019.67V145.807ZM1026.11 74.9902H948.899V71.7734H1026.11V74.9902Z"
    ],
    "x": 987.5295000000001
  },
  {
    "y": 106.08630000000001,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1022.49 140.532H1073.63H1080.32V127.456H1093.32V71.6406H1022.49V140.532Z",
      "M1083.47 130.641L1083.46 140.65H1086.83V142.043H1090.05V138.826H1093.31V130.641H1083.47Z",
      "M1022.49 140.646H1080.24V127.461H1093.25V71.4844H1096.48V136.021H1093.26V139.006H1090.05V135.789H1093.25V130.678H1083.45V140.646H1086.83V143.863H1019.27V71.4844H1022.49V140.646ZM1090.05 142.299H1086.83V139.082H1090.05V142.299ZM1096.48 71.4824H1019.27V68.2656H1096.48V71.4824Z"
    ],
    "x": 1057.905
  },
  {
    "y": 103.91489999999999,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1092.92 138.361H1144.06H1150.75V125.284H1163.75V69.4688H1092.92V138.361Z",
      "M1153.9 128.469L1153.88 138.478H1157.26V139.871H1160.48V136.654H1163.74V128.469H1153.9Z",
      "M1092.92 138.475H1150.67V125.289H1163.68V69.3125H1166.91V133.85H1163.69V136.834H1160.48V133.617H1163.68V128.506H1153.88V138.475H1157.26V141.691H1089.7V69.3125H1092.92V138.475ZM1160.48 140.127H1157.26V136.91H1160.48V140.127ZM1166.91 69.3105H1089.7V66.0938H1166.91V69.3105Z"
    ],
    "x": 1128.335
  },
  {
    "y": 102.9109,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1163.38 137.357H1214.52H1221.2V124.28H1234.2V68.4648H1163.38V137.357Z",
      "M1224.35 127.465L1224.34 137.474H1227.72V138.867H1230.93V135.65H1234.2V127.465H1224.35Z",
      "M1163.38 137.471H1221.12V124.285H1234.13V68.3086H1237.37V132.846H1234.15V135.83H1230.93V132.613H1234.13V127.502H1224.34V137.471H1227.72V140.688H1160.16V68.3086H1163.38V137.471ZM1230.93 139.123H1227.72V135.906H1230.93V139.123ZM1237.37 68.3066H1160.16V65.0898H1237.37V68.3066Z"
    ],
    "x": 1198.79
  },
  {
    "y": 102.84815,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1233.84 137.294H1284.98H1291.67V124.218H1304.66V68.4023H1233.84V137.294Z",
      "M1294.82 127.402L1294.8 137.412H1298.18V138.804H1301.4V135.587H1304.66V127.402H1294.82Z",
      "M1233.84 137.408H1291.58V124.223H1304.59V68.2461H1307.83V132.783H1304.61V135.768H1301.4V132.551H1304.59V127.439H1294.8V137.408H1298.18V140.625H1230.62V68.2461H1233.84V137.408ZM1301.4 139.061H1298.18V135.844H1301.4V139.061ZM1307.83 68.2441H1230.62V65.0273H1307.83V68.2441Z"
    ],
    "x": 1269.25
  },
  {
    "y": 103.31309999999999,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1304.3 137.759H1355.44H1362.13V124.682H1375.13V68.8672H1304.3V137.759Z",
      "M1365.28 127.867L1365.27 137.877H1368.64V139.269H1371.86V136.052H1375.12V127.867H1365.28Z",
      "M1304.3 137.873H1362.05V124.688H1375.06V68.7109H1378.29V133.248H1375.08V136.232H1371.86V133.016H1375.06V127.904H1365.26V137.873H1368.64V141.09H1301.08V68.7109H1304.3V137.873ZM1371.86 139.525H1368.64V136.309H1371.86V139.525ZM1378.29 68.709H1301.08V65.4922H1378.29V68.709Z"
    ],
    "x": 1339.7150000000001
  },
  {
    "y": 104.3561,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1374.76 138.802H1425.9H1432.59V125.725H1445.58V69.9102H1374.76V138.802Z",
      "M1435.74 128.91L1435.72 138.92H1439.1V140.312H1442.32V137.095H1445.58V128.91H1435.74Z",
      "M1374.76 138.916H1432.5V125.73H1445.51V69.7539H1448.75V134.291H1445.53V137.275H1442.31V134.059H1445.51V128.947H1435.72V138.916H1439.1V142.133H1371.54V69.7539H1374.76V138.916ZM1442.31 140.568H1439.1V137.352H1442.31V140.568ZM1448.75 69.752H1371.54V66.5352H1448.75V69.752Z"
    ],
    "x": 1410.17
  },
  {
    "y": 106.7311,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1445.17 141.177H1496.31H1503V128.1H1516V72.2852H1445.17V141.177Z",
      "M1506.15 131.285L1506.13 141.295H1509.51V142.687H1512.73V139.47H1515.99V131.285H1506.15Z",
      "M1445.17 141.291H1502.92V128.105H1515.93V72.1289H1519.16V136.666H1515.94V139.65H1512.73V136.434H1515.93V131.322H1506.13V141.291H1509.51V144.508H1441.95V72.1289H1445.17V141.291ZM1512.73 142.943H1509.51V139.727H1512.73V142.943ZM1519.16 72.127H1441.95V68.9102H1519.16V72.127Z"
    ],
    "x": 1480.585
  },
  {
    "y": 132.1219,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1479.22 166.568H1530.36H1537.05V153.491H1550.04V97.6758H1479.22V166.568Z",
      "M1540.2 156.676L1540.18 166.685H1543.56V168.078H1546.78V164.861H1550.04V156.676H1540.2Z",
      "M1479.22 166.682H1536.96V153.496H1549.97V97.5195H1553.21V162.057H1549.99V165.041H1546.77V161.824H1549.97V156.713H1540.18V166.682H1543.56V169.898H1476V97.5195H1479.22V166.682ZM1546.78 168.334H1543.56V165.117H1546.78V168.334ZM1553.21 97.5176H1476V94.3008H1553.21V97.5176Z"
    ],
    "x": 1514.63
  },
  {
    "y": 419.32899999999995,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1203.54 453.775H1254.67H1261.36V440.698H1274.36V384.883H1203.54V453.775Z",
      "M1264.51 443.883L1264.5 453.892H1267.87V455.285H1271.09V452.068H1274.35V443.883H1264.51Z",
      "M1203.53 453.889H1261.28V440.703H1274.29V384.727H1277.52V449.264H1274.31V452.248H1271.09V449.031H1274.29V443.92H1264.5V453.889H1267.87V457.105H1200.31V384.727H1203.53V453.889ZM1271.09 455.541H1267.87V452.324H1271.09V455.541ZM1277.52 384.725H1200.32V381.508H1277.52V384.725Z"
    ],
    "x": 1238.9499999999998
  },
  {
    "y": 441.32899999999995,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M895.535 475.775H946.674H953.361V462.698H966.357V406.883H895.535V475.775Z",
      "M956.511 465.883L956.496 475.892H959.874V477.285H963.091V474.068H966.353V465.883H956.511Z",
      "M895.532 475.889H953.278V462.703H966.287V406.727H969.523V471.264H966.306V474.248H963.089V471.031H966.287V465.92H956.495V475.889H959.872V479.105H892.314V406.727H895.532V475.889ZM963.09 477.541H959.873V474.324H963.09V477.541ZM969.523 406.725H892.315V403.508H969.523V406.725Z"
    ],
    "x": 930.9459999999999
  },
  {
    "y": 485.32899999999995,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1467.54 519.775H1518.67H1525.36V506.698H1538.36V450.883H1467.54V519.775Z",
      "M1528.51 509.883L1528.5 519.892H1531.87V521.285H1535.09V518.068H1538.35V509.883H1528.51Z",
      "M1467.53 519.889H1525.28V506.703H1538.29V450.727H1541.52V515.264H1538.31V518.248H1535.09V515.031H1538.29V509.92H1528.5V519.889H1531.87V523.105H1464.31V450.727H1467.53V519.889ZM1535.09 521.541H1531.87V518.324H1535.09V521.541ZM1541.52 450.725H1464.32V447.508H1541.52V450.725Z"
    ],
    "x": 1502.9499999999998
  },
  {
    "y": 507.32899999999995,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M654.535 541.775H705.674H712.361V528.698H725.357V472.883H654.535V541.775Z",
      "M715.511 531.883L715.496 541.892H718.874V543.285H722.091V540.068H725.353V531.883H715.511Z",
      "M654.532 541.889H712.278V528.703H725.287V472.727H728.523V537.264H725.306V540.248H722.089V537.031H725.287V531.92H715.495V541.889H718.872V545.105H651.314V472.727H654.532V541.889ZM722.09 543.541H718.873V540.324H722.09V543.541ZM728.523 472.725H651.315V469.508H728.523V472.725Z"
    ],
    "x": 689.9459999999999
  },
  {
    "y": 554.329,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M340.035 588.775H391.174H397.861V575.698H410.857V519.883H340.035V588.775Z",
      "M401.011 578.883L400.996 588.892H404.374V590.285H407.591V587.068H410.853V578.883H401.011Z",
      "M340.032 588.889H397.778V575.703H410.787V519.727H414.023V584.264H410.806V587.248H407.589V584.031H410.787V578.92H400.995V588.889H404.372V592.105H336.814V519.727H340.032V588.889ZM407.59 590.541H404.373V587.324H407.59V590.541ZM414.023 519.725H336.815V516.508H414.023V519.725Z"
    ],
    "x": 375.446
  },
  {
    "y": 564.329,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M280.035 598.775H331.174H337.861V585.698H350.857V529.883H280.035V598.775Z",
      "M341.011 588.883L340.996 598.892H344.374V600.285H347.591V597.068H350.853V588.883H341.011Z",
      "M280.032 598.889H337.778V585.703H350.787V529.727H354.023V594.264H350.806V597.248H347.589V594.031H350.787V588.92H340.995V598.889H344.372V602.105H276.814V529.727H280.032V598.889ZM347.59 600.541H344.373V597.324H347.59V600.541ZM354.023 529.725H276.815V526.508H354.023V529.725Z"
    ],
    "x": 315.446
  },
  {
    "y": 299.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1368.54 333.775H1419.67H1426.36V320.698H1439.36V264.883H1368.54V333.775Z",
      "M1429.51 323.883L1429.5 333.892H1432.87V335.285H1436.09V332.068H1439.35V323.883H1429.51Z",
      "M1368.53 333.889H1426.28V320.703H1439.29V264.727H1442.52V329.264H1439.31V332.248H1436.09V329.031H1439.29V323.92H1429.5V333.889H1432.87V337.105H1365.31V264.727H1368.53V333.889ZM1436.09 335.541H1432.87V332.324H1436.09V335.541ZM1442.52 264.725H1365.32V261.508H1442.52V264.725Z"
    ],
    "x": 1403.9499999999998
  },
  {
    "y": 309.32899999999995,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1038.54 343.775H1089.67H1096.36V330.698H1109.36V274.883H1038.54V343.775Z",
      "M1099.51 333.883L1099.5 343.892H1102.87V345.285H1106.09V342.068H1109.35V333.883H1099.51Z",
      "M1038.53 343.889H1096.28V330.703H1109.29V274.727H1112.52V339.264H1109.31V342.248H1106.09V339.031H1109.29V333.92H1099.5V343.889H1102.87V347.105H1035.31V274.727H1038.53V343.889ZM1106.09 345.541H1102.87V342.324H1106.09V345.541ZM1112.52 274.725H1035.32V271.508H1112.52V274.725Z"
    ],
    "x": 1073.9499999999998
  },
  {
    "y": 571.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1049.54 605.775H1100.67H1107.36V592.698H1120.36V536.883H1049.54V605.775Z",
      "M1110.51 595.883L1110.5 605.892H1113.87V607.285H1117.09V604.068H1120.35V595.883H1110.51Z",
      "M1049.53 605.889H1107.28V592.703H1120.29V536.727H1123.52V601.264H1120.31V604.248H1117.09V601.031H1120.29V595.92H1110.5V605.889H1113.87V609.105H1046.31V536.727H1049.53V605.889ZM1117.09 607.541H1113.87V604.324H1117.09V607.541ZM1123.52 536.725H1046.32V533.508H1123.52V536.725Z"
    ],
    "x": 1084.9499999999998
  },
  {
    "y": 562.329,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1308.04 596.775H1359.17H1365.86V583.698H1378.86V527.883H1308.04V596.775Z",
      "M1369.01 586.883L1369 596.892H1372.37V598.285H1375.59V595.068H1378.85V586.883H1369.01Z",
      "M1308.03 596.889H1365.78V583.703H1378.79V527.727H1382.02V592.264H1378.81V595.248H1375.59V592.031H1378.79V586.92H1369V596.889H1372.37V600.105H1304.81V527.727H1308.03V596.889ZM1375.59 598.541H1372.37V595.324H1375.59V598.541ZM1382.02 527.725H1304.82V524.508H1382.02V527.725Z"
    ],
    "x": 1343.4499999999998
  },
  {
    "y": 531.598,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M486.807 566.044H537.945H544.633V552.968H557.629V497.152H486.807V566.044Z",
      "M547.782 556.152L547.768 566.162H551.145V567.554H554.362V564.337H557.624V556.152H547.782Z",
      "M486.804 566.158H544.55V552.973H557.559V496.996H560.795V561.533H557.577V564.518H554.36V561.301H557.559V556.189H547.767V566.158H551.144V569.375H483.586V496.996H486.804V566.158ZM554.361 567.811H551.145V564.594H554.361V567.811ZM560.795 496.994H483.587V493.777H560.795V496.994Z"
    ],
    "x": 522.2180000000001
  },
  {
    "y": 364.32899999999995,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M747.035 398.775H798.174H804.861V385.698H817.857V329.883H747.035V398.775Z",
      "M808.011 388.883L807.996 398.892H811.374V400.285H814.591V397.068H817.853V388.883H808.011Z",
      "M747.032 398.889H804.778V385.703H817.787V329.727H821.023V394.264H817.806V397.248H814.589V394.031H817.787V388.92H807.995V398.889H811.372V402.105H743.814V329.727H747.032V398.889ZM814.59 400.541H811.373V397.324H814.59V400.541ZM821.023 329.725H743.815V326.508H821.023V329.725Z"
    ],
    "x": 782.4459999999999
  },
  {
    "y": 584.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M824.035 618.775H875.174H881.861V605.698H894.857V549.883H824.035V618.775Z",
      "M885.011 608.883L884.996 618.892H888.374V620.285H891.591V617.068H894.853V608.883H885.011Z",
      "M824.032 618.889H881.778V605.703H894.787V549.727H898.023V614.264H894.806V617.248H891.589V614.031H894.787V608.92H884.995V618.889H888.372V622.105H820.814V549.727H824.032V618.889ZM891.59 620.541H888.373V617.324H891.59V620.541ZM898.023 549.725H820.815V546.508H898.023V549.725Z"
    ],
    "x": 859.4459999999999
  },
  {
    "y": 254.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1198.04 288.775H1249.17H1255.86V275.698H1268.86V219.883H1198.04V288.775Z",
      "M1259.01 278.883L1259 288.892H1262.37V290.285H1265.59V287.068H1268.85V278.883H1259.01Z",
      "M1198.03 288.889H1255.78V275.703H1268.79V219.727H1272.02V284.264H1268.81V287.248H1265.59V284.031H1268.79V278.92H1259V288.889H1262.37V292.105H1194.81V219.727H1198.03V288.889ZM1265.59 290.541H1262.37V287.324H1265.59V290.541ZM1272.02 219.725H1194.82V216.508H1272.02V219.725Z"
    ],
    "x": 1233.4499999999998
  },
  {
    "y": 287.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M884.535 321.775H935.674H942.361V308.698H955.357V252.883H884.535V321.775Z",
      "M945.511 311.883L945.496 321.892H948.874V323.285H952.091V320.068H955.353V311.883H945.511Z",
      "M884.532 321.889H942.278V308.703H955.287V252.727H958.523V317.264H955.306V320.248H952.089V317.031H955.287V311.92H945.495V321.889H948.872V325.105H881.314V252.727H884.532V321.889ZM952.09 323.541H948.873V320.324H952.09V323.541ZM958.523 252.725H881.315V249.508H958.523V252.725Z"
    ],
    "x": 919.9459999999999
  },
  {
    "y": 347.32899999999995,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1528.04 381.775H1579.17H1585.86V368.698H1598.86V312.883H1528.04V381.775Z",
      "M1589.01 371.883L1589 381.892H1592.37V383.285H1595.59V380.068H1598.85V371.883H1589.01Z",
      "M1528.03 381.889H1585.78V368.703H1598.79V312.727H1602.02V377.264H1598.81V380.248H1595.59V377.031H1598.79V371.92H1589V381.889H1592.37V385.105H1524.81V312.727H1528.03V381.889ZM1595.59 383.541H1592.37V380.324H1595.59V383.541ZM1602.02 312.725H1524.82V309.508H1602.02V312.725Z"
    ],
    "x": 1563.4499999999998
  },
  {
    "y": 551.598,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M193.807 586.044H244.945H251.633V572.968H264.629V517.152H193.807V586.044Z",
      "M254.782 576.152L254.768 586.162H258.145V587.554H261.362V584.337H264.624V576.152H254.782Z",
      "M193.804 586.158H251.55V572.973H264.559V516.996H267.795V581.533H264.577V584.518H261.36V581.301H264.559V576.189H254.767V586.158H258.144V589.375H190.586V516.996H193.804V586.158ZM261.361 587.811H258.145V584.594H261.361V587.811ZM267.795 516.994H190.587V513.777H267.795V516.994Z"
    ],
    "x": 229.21800000000002
  },
  {
    "y": 551.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1590.54 585.775H1641.67H1648.36V572.698H1661.36V516.883H1590.54V585.775Z",
      "M1651.51 575.883L1651.5 585.892H1654.87V587.285H1658.09V584.068H1661.35V575.883H1651.51Z",
      "M1590.53 585.889H1648.28V572.703H1661.29V516.727H1664.52V581.264H1661.31V584.248H1658.09V581.031H1661.29V575.92H1651.5V585.889H1654.87V589.105H1587.31V516.727H1590.53V585.889ZM1658.09 587.541H1654.87V584.324H1658.09V587.541ZM1664.52 516.725H1587.32V513.508H1664.52V516.725Z"
    ],
    "x": 1625.9499999999998
  },
  {
    "y": 606.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1176.04 640.775H1227.17H1233.86V627.698H1246.86V571.883H1176.04V640.775Z",
      "M1237.01 630.883L1237 640.892H1240.37V642.285H1243.59V639.068H1246.85V630.883H1237.01Z",
      "M1176.03 640.889H1233.78V627.703H1246.79V571.727H1250.02V636.264H1246.81V639.248H1243.59V636.031H1246.79V630.92H1237V640.889H1240.37V644.105H1172.81V571.727H1176.03V640.889ZM1243.59 642.541H1240.37V639.324H1243.59V642.541ZM1250.02 571.725H1172.82V568.508H1250.02V571.725Z"
    ],
    "x": 1211.4499999999998
  },
  {
    "y": 430.32899999999995,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1330.04 464.775H1381.17H1387.86V451.698H1400.86V395.883H1330.04V464.775Z",
      "M1391.01 454.883L1391 464.892H1394.37V466.285H1397.59V463.068H1400.85V454.883H1391.01Z",
      "M1330.03 464.889H1387.78V451.703H1400.79V395.727H1404.02V460.264H1400.81V463.248H1397.59V460.031H1400.79V454.92H1391V464.889H1394.37V468.105H1326.81V395.727H1330.03V464.889ZM1397.59 466.541H1394.37V463.324H1397.59V466.541ZM1404.02 395.725H1326.82V392.508H1404.02V395.725Z"
    ],
    "x": 1365.4499999999998
  },
  {
    "y": 617.329,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M572.035 651.775H623.174H629.861V638.698H642.857V582.883H572.035V651.775Z",
      "M633.011 641.883L632.996 651.892H636.374V653.285H639.591V650.068H642.853V641.883H633.011Z",
      "M572.032 651.889H629.778V638.703H642.787V582.727H646.023V647.264H642.806V650.248H639.589V647.031H642.787V641.92H632.995V651.889H636.372V655.105H568.814V582.727H572.032V651.889ZM639.59 653.541H636.373V650.324H639.59V653.541ZM646.023 582.725H568.815V579.508H646.023V582.725Z"
    ],
    "x": 607.4459999999999
  },
  {
    "y": 430.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1077.04 464.775H1128.17H1134.86V451.698H1147.86V395.883H1077.04V464.775Z",
      "M1138.01 454.883L1138 464.892H1141.37V466.285H1144.59V463.068H1147.85V454.883H1138.01Z",
      "M1077.03 464.889H1134.78V451.703H1147.79V395.727H1151.02V460.264H1147.81V463.248H1144.59V460.031H1147.79V454.92H1138V464.889H1141.37V468.105H1073.81V395.727H1077.03V464.889ZM1144.59 466.541H1141.37V463.324H1144.59V466.541ZM1151.02 395.725H1073.82V392.508H1151.02V395.725Z"
    ],
    "x": 1112.4499999999998
  },
  {
    "y": 463.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M356.535 497.775H407.674H414.361V484.698H427.357V428.883H356.535V497.775Z",
      "M417.511 487.883L417.496 497.892H420.874V499.285H424.091V496.068H427.353V487.883H417.511Z",
      "M356.532 497.889H414.278V484.703H427.287V428.727H430.523V493.264H427.306V496.248H424.089V493.031H427.287V487.92H417.495V497.889H420.872V501.105H353.314V428.727H356.532V497.889ZM424.09 499.541H420.873V496.324H424.09V499.541ZM430.523 428.725H353.315V425.508H430.523V428.725Z"
    ],
    "x": 391.946
  },
  {
    "y": 617.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M939.535 651.775H990.674H997.361V638.698H1010.36V582.883H939.535V651.775Z",
      "M1000.51 641.883L1000.5 651.892H1003.87V653.285H1007.09V650.068H1010.35V641.883H1000.51Z",
      "M939.532 651.889H997.278V638.703H1010.29V582.727H1013.52V647.264H1010.31V650.248H1007.09V647.031H1010.29V641.92H1000.5V651.889H1003.87V655.105H936.314V582.727H939.532V651.889ZM1007.09 653.541H1003.87V650.324H1007.09V653.541ZM1013.52 582.725H936.315V579.508H1013.52V582.725Z"
    ],
    "x": 974.9475
  },
  {
    "y": 427.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M610.535 461.775H661.674H668.361V448.698H681.357V392.883H610.535V461.775Z",
      "M671.511 451.883L671.496 461.892H674.874V463.285H678.091V460.068H681.353V451.883H671.511Z",
      "M610.532 461.889H668.278V448.703H681.287V392.727H684.523V457.264H681.306V460.248H678.089V457.031H681.287V451.92H671.495V461.889H674.872V465.105H607.314V392.727H610.532V461.889ZM678.09 463.541H674.873V460.324H678.09V463.541ZM684.523 392.725H607.315V389.508H684.523V392.725Z"
    ],
    "x": 645.9459999999999
  },
  {
    "y": 617.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M708.535 651.775H759.674H766.361V638.698H779.357V582.883H708.535V651.775Z",
      "M769.511 641.883L769.496 651.892H772.874V653.285H776.091V650.068H779.353V641.883H769.511Z",
      "M708.532 651.889H766.278V638.703H779.287V582.727H782.523V647.264H779.306V650.248H776.089V647.031H779.287V641.92H769.495V651.889H772.872V655.105H705.314V582.727H708.532V651.889ZM776.09 653.541H772.873V650.324H776.09V653.541ZM782.523 582.725H705.315V579.508H782.523V582.725Z"
    ],
    "x": 743.9459999999999
  },
  {
    "y": 610.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M455.035 644.775H506.174H512.861V631.698H525.857V575.883H455.035V644.775Z",
      "M516.011 634.883L515.996 644.892H519.374V646.285H522.591V643.068H525.853V634.883H516.011Z",
      "M455.032 644.889H512.778V631.703H525.787V575.727H529.023V640.264H525.806V643.248H522.589V640.031H525.787V634.92H515.995V644.889H519.372V648.105H451.814V575.727H455.032V644.889ZM522.59 646.541H519.373V643.324H522.59V646.541ZM529.023 575.725H451.815V572.508H529.023V575.725Z"
    ],
    "x": 490.446
  },
  {
    "y": 450.32899999999995,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1606.04 484.775H1657.17H1663.86V471.698H1676.86V415.883H1606.04V484.775Z",
      "M1667.01 474.883L1667 484.892H1670.37V486.285H1673.59V483.068H1676.85V474.883H1667.01Z",
      "M1606.03 484.889H1663.78V471.703H1676.79V415.727H1680.02V480.264H1676.81V483.248H1673.59V480.031H1676.79V474.92H1667V484.889H1670.37V488.105H1602.81V415.727H1606.03V484.889ZM1673.59 486.541H1670.37V483.324H1673.59V486.541ZM1680.02 415.725H1602.82V412.508H1680.02V415.725Z"
    ],
    "x": 1641.4499999999998
  },
  {
    "y": 243.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1467.54 277.775H1518.67H1525.36V264.698H1538.36V208.883H1467.54V277.775Z",
      "M1528.51 267.883L1528.5 277.892H1531.87V279.285H1535.09V276.068H1538.35V267.883H1528.51Z",
      "M1467.53 277.889H1525.28V264.703H1538.29V208.727H1541.52V273.264H1538.31V276.248H1535.09V273.031H1538.29V267.92H1528.5V277.889H1531.87V281.105H1464.31V208.727H1467.53V277.889ZM1535.09 279.541H1531.87V276.324H1535.09V279.541ZM1541.52 208.725H1464.32V205.508H1541.52V208.725Z"
    ],
    "x": 1502.9499999999998
  },
  {
    "y": 474.32899999999995,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M780.035 508.775H831.174H837.861V495.698H850.857V439.883H780.035V508.775Z",
      "M841.011 498.883L840.996 508.892H844.374V510.285H847.591V507.068H850.853V498.883H841.011Z",
      "M780.032 508.889H837.778V495.703H850.787V439.727H854.023V504.264H850.806V507.248H847.589V504.031H850.787V498.92H840.995V508.889H844.372V512.105H776.814V439.727H780.032V508.889ZM847.59 510.541H844.373V507.324H847.59V510.541ZM854.023 439.725H776.815V436.508H854.023V439.725Z"
    ],
    "x": 815.4459999999999
  },
  {
    "y": 221.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M972.535 255.775H1023.67H1030.36V242.698H1043.36V186.883H972.535V255.775Z",
      "M1033.51 245.883L1033.5 255.892H1036.87V257.285H1040.09V254.068H1043.35V245.883H1033.51Z",
      "M972.532 255.889H1030.28V242.703H1043.29V186.727H1046.52V251.264H1043.31V254.248H1040.09V251.031H1043.29V245.92H1033.5V255.889H1036.87V259.105H969.314V186.727H972.532V255.889ZM1040.09 257.541H1036.87V254.324H1040.09V257.541ZM1046.52 186.725H969.315V183.508H1046.52V186.725Z"
    ],
    "x": 1007.9475
  },
  {
    "y": 221.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1302.54 255.775H1353.67H1360.36V242.698H1373.36V186.883H1302.54V255.775Z",
      "M1363.51 245.883L1363.5 255.892H1366.87V257.285H1370.09V254.068H1373.35V245.883H1363.51Z",
      "M1302.53 255.889H1360.28V242.703H1373.29V186.727H1376.52V251.264H1373.31V254.248H1370.09V251.031H1373.29V245.92H1363.5V255.889H1366.87V259.105H1299.31V186.727H1302.53V255.889ZM1370.09 257.541H1366.87V254.324H1370.09V257.541ZM1376.52 186.725H1299.32V183.508H1376.52V186.725Z"
    ],
    "x": 1337.9499999999998
  },
  {
    "y": 210.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1099.04 244.775H1150.17H1156.86V231.698H1169.86V175.883H1099.04V244.775Z",
      "M1160.01 234.883L1160 244.892H1163.37V246.285H1166.59V243.068H1169.85V234.883H1160.01Z",
      "M1099.03 244.889H1156.78V231.703H1169.79V175.727H1173.02V240.264H1169.81V243.248H1166.59V240.031H1169.79V234.92H1160V244.889H1163.37V248.105H1095.81V175.727H1099.03V244.889ZM1166.59 246.541H1163.37V243.324H1166.59V246.541ZM1173.02 175.725H1095.82V172.508H1173.02V175.725Z"
    ],
    "x": 1134.4499999999998
  },
  {
    "y": 619.329,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1359.54 653.775H1410.67H1417.36V640.698H1430.36V584.883H1359.54V653.775Z",
      "M1420.51 643.883L1420.5 653.892H1423.87V655.285H1427.09V652.068H1430.35V643.883H1420.51Z",
      "M1359.53 653.889H1417.28V640.703H1430.29V584.727H1433.52V649.264H1430.31V652.248H1427.09V649.031H1430.29V643.92H1420.5V653.889H1423.87V657.105H1356.31V584.727H1359.53V653.889ZM1427.09 655.541H1423.87V652.324H1427.09V655.541ZM1433.52 584.725H1356.32V581.508H1433.52V584.725Z"
    ],
    "x": 1394.9499999999998
  },
  {
    "y": 463.32899999999995,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M246.535 497.775H297.674H304.361V484.698H317.357V428.883H246.535V497.775Z",
      "M307.511 487.883L307.496 497.892H310.874V499.285H314.091V496.068H317.353V487.883H307.511Z",
      "M246.532 497.889H304.278V484.703H317.287V428.727H320.523V493.264H317.306V496.248H314.089V493.031H317.287V487.92H307.495V497.889H310.872V501.105H243.314V428.727H246.532V497.889ZM314.09 499.541H310.873V496.324H314.09V499.541ZM320.523 428.725H243.315V425.508H320.523V428.725Z"
    ],
    "x": 281.946
  },
  {
    "y": 534.598,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1148.81 569.044H1199.95H1206.63V555.968H1219.63V500.152H1148.81V569.044Z",
      "M1209.78 559.152L1209.77 569.162H1213.15V570.554H1216.36V567.337H1219.62V559.152H1209.78Z",
      "M1148.8 569.158H1206.55V555.973H1219.56V499.996H1222.79V564.533H1219.58V567.518H1216.36V564.301H1219.56V559.189H1209.77V569.158H1213.14V572.375H1145.59V499.996H1148.8V569.158ZM1216.36 570.811H1213.14V567.594H1216.36V570.811ZM1222.79 499.994H1145.59V496.777H1222.79V499.994Z"
    ],
    "x": 1184.22
  },
  {
    "y": 331.32899999999995,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1269.54 365.775H1320.67H1327.36V352.698H1340.36V296.883H1269.54V365.775Z",
      "M1330.51 355.883L1330.5 365.892H1333.87V367.285H1337.09V364.068H1340.35V355.883H1330.51Z",
      "M1269.53 365.889H1327.28V352.703H1340.29V296.727H1343.52V361.264H1340.31V364.248H1337.09V361.031H1340.29V355.92H1330.5V365.889H1333.87V369.105H1266.31V296.727H1269.53V365.889ZM1337.09 367.541H1333.87V364.324H1337.09V367.541ZM1343.52 296.725H1266.32V293.508H1343.52V296.725Z"
    ],
    "x": 1304.9499999999998
  },
  {
    "y": 342.32899999999995,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1132.04 376.775H1183.17H1189.86V363.698H1202.86V307.883H1132.04V376.775Z",
      "M1193.01 366.883L1193 376.892H1196.37V378.285H1199.59V375.068H1202.85V366.883H1193.01Z",
      "M1132.03 376.889H1189.78V363.703H1202.79V307.727H1206.02V372.264H1202.81V375.248H1199.59V372.031H1202.79V366.92H1193V376.889H1196.37V380.105H1128.81V307.727H1132.03V376.889ZM1199.59 378.541H1196.37V375.324H1199.59V378.541ZM1206.02 307.725H1128.82V304.508H1206.02V307.725Z"
    ],
    "x": 1167.4499999999998
  },
  {
    "y": 386.32899999999995,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1440.04 420.775H1491.17H1497.86V407.698H1510.86V351.883H1440.04V420.775Z",
      "M1501.01 410.883L1501 420.892H1504.37V422.285H1507.59V419.068H1510.85V410.883H1501.01Z",
      "M1440.03 420.889H1497.78V407.703H1510.79V351.727H1514.02V416.264H1510.81V419.248H1507.59V416.031H1510.79V410.92H1501V420.889H1504.37V424.105H1436.81V351.727H1440.03V420.889ZM1507.59 422.541H1504.37V419.324H1507.59V422.541ZM1514.02 351.725H1436.82V348.508H1514.02V351.725Z"
    ],
    "x": 1475.4499999999998
  },
  {
    "y": 397.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M983.535 431.775H1034.67H1041.36V418.698H1054.36V362.883H983.535V431.775Z",
      "M1044.51 421.883L1044.5 431.892H1047.87V433.285H1051.09V430.068H1054.35V421.883H1044.51Z",
      "M983.532 431.889H1041.28V418.703H1054.29V362.727H1057.52V427.264H1054.31V430.248H1051.09V427.031H1054.29V421.92H1044.5V431.889H1047.87V435.105H980.314V362.727H983.532V431.889ZM1051.09 433.541H1047.87V430.324H1051.09V433.541ZM1057.52 362.725H980.315V359.508H1057.52V362.725Z"
    ],
    "x": 1018.9475
  },
  {
    "y": 518.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M956.035 552.775H1007.17H1013.86V539.698H1026.86V483.883H956.035V552.775Z",
      "M1017.01 542.883L1017 552.892H1020.37V554.285H1023.59V551.068H1026.85V542.883H1017.01Z",
      "M956.032 552.889H1013.78V539.703H1026.79V483.727H1030.02V548.264H1026.81V551.248H1023.59V548.031H1026.79V542.92H1017V552.889H1020.37V556.105H952.814V483.727H956.032V552.889ZM1023.59 554.541H1020.37V551.324H1023.59V554.541ZM1030.02 483.725H952.815V480.508H1030.02V483.725Z"
    ],
    "x": 991.4475
  },
  {
    "y": 619.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M131.035 653.775H182.174H188.861V640.698H201.857V584.883H131.035V653.775Z",
      "M192.011 643.883L191.996 653.892H195.374V655.285H198.591V652.068H201.853V643.883H192.011Z",
      "M131.032 653.889H188.778V640.703H201.787V584.727H205.023V649.264H201.806V652.248H198.589V649.031H201.787V643.92H191.995V653.889H195.372V657.105H127.814V584.727H131.032V653.889ZM198.59 655.541H195.373V652.324H198.59V655.541ZM205.023 584.725H127.815V581.508H205.023V584.725Z"
    ],
    "x": 166.446
  },
  {
    "y": 419.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M499.535 453.775H550.674H557.361V440.698H570.357V384.883H499.535V453.775Z",
      "M560.511 443.883L560.496 453.892H563.874V455.285H567.091V452.068H570.353V443.883H560.511Z",
      "M499.532 453.889H557.278V440.703H570.287V384.727H573.523V449.264H570.306V452.248H567.089V449.031H570.287V443.92H560.495V453.889H563.872V457.105H496.314V384.727H499.532V453.889ZM567.09 455.541H563.873V452.324H567.09V455.541ZM573.523 384.725H496.315V381.508H573.523V384.725Z"
    ],
    "x": 534.946
  },
  {
    "y": 276.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M791.035 310.775H842.174H848.861V297.698H861.857V241.883H791.035V310.775Z",
      "M852.011 300.883L851.996 310.892H855.374V312.285H858.591V309.068H861.853V300.883H852.011Z",
      "M791.032 310.889H848.778V297.703H861.787V241.727H865.023V306.264H861.806V309.248H858.589V306.031H861.787V300.92H851.995V310.889H855.372V314.105H787.814V241.727H791.032V310.889ZM858.59 312.541H855.373V309.324H858.59V312.541ZM865.023 241.725H787.815V238.508H865.023V241.725Z"
    ],
    "x": 826.4459999999999
  },
  {
    "y": 474.32899999999995,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M142.035 508.775H193.174H199.861V495.698H212.857V439.883H142.035V508.775Z",
      "M203.011 498.883L202.996 508.892H206.374V510.285H209.591V507.068H212.853V498.883H203.011Z",
      "M142.032 508.889H199.778V495.703H212.787V439.727H216.023V504.264H212.806V507.248H209.589V504.031H212.787V498.92H202.995V508.889H206.372V512.105H138.814V439.727H142.032V508.889ZM209.59 510.541H206.373V507.324H209.59V510.541ZM216.023 439.725H138.815V436.508H216.023V439.725Z"
    ],
    "x": 177.446
  },
  {
    "y": 650.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1264.04 684.775H1315.17H1321.86V671.698H1334.86V615.883H1264.04V684.775Z",
      "M1325.01 674.883L1325 684.892H1328.37V686.285H1331.59V683.068H1334.85V674.883H1325.01Z",
      "M1264.03 684.889H1321.78V671.703H1334.79V615.727H1338.02V680.264H1334.81V683.248H1331.59V680.031H1334.79V674.92H1325V684.889H1328.37V688.105H1260.81V615.727H1264.03V684.889ZM1331.59 686.541H1328.37V683.324H1331.59V686.541ZM1338.02 615.725H1260.82V612.508H1338.02V615.725Z"
    ],
    "x": 1299.4499999999998
  },
  {
    "y": 541.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1401.54 575.775H1452.67H1459.36V562.698H1472.36V506.883H1401.54V575.775Z",
      "M1462.51 565.883L1462.5 575.892H1465.87V577.285H1469.09V574.068H1472.35V565.883H1462.51Z",
      "M1401.53 575.889H1459.28V562.703H1472.29V506.727H1475.52V571.264H1472.31V574.248H1469.09V571.031H1472.29V565.92H1462.5V575.889H1465.87V579.105H1398.31V506.727H1401.53V575.889ZM1469.09 577.541H1465.87V574.324H1469.09V577.541ZM1475.52 506.725H1398.32V503.508H1475.52V506.725Z"
    ],
    "x": 1436.9499999999998
  },
  {
    "y": 562.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1517.04 596.775H1568.17H1574.86V583.698H1587.86V527.883H1517.04V596.775Z",
      "M1578.01 586.883L1578 596.892H1581.37V598.285H1584.59V595.068H1587.85V586.883H1578.01Z",
      "M1517.03 596.889H1574.78V583.703H1587.79V527.727H1591.02V592.264H1587.81V595.248H1584.59V592.031H1587.79V586.92H1578V596.889H1581.37V600.105H1513.81V527.727H1517.03V596.889ZM1584.59 598.541H1581.37V595.324H1584.59V598.541ZM1591.02 527.725H1513.82V524.508H1591.02V527.725Z"
    ],
    "x": 1552.4499999999998
  },
  {
    "y": 532.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1647.04 566.775H1698.17H1704.86V553.698H1717.86V497.883H1647.04V566.775Z",
      "M1708.01 556.883L1708 566.892H1711.37V568.285H1714.59V565.068H1717.85V556.883H1708.01Z",
      "M1647.03 566.889H1704.78V553.703H1717.79V497.727H1721.02V562.264H1717.81V565.248H1714.59V562.031H1717.79V556.92H1708V566.889H1711.37V570.105H1643.81V497.727H1647.03V566.889ZM1714.59 568.541H1711.37V565.324H1714.59V568.541ZM1721.02 497.725H1643.82V494.508H1721.02V497.725Z"
    ],
    "x": 1682.4499999999998
  },
  {
    "y": 485.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M576.535 519.775H627.674H634.361V506.698H647.357V450.883H576.535V519.775Z",
      "M637.511 509.883L637.496 519.892H640.874V521.285H644.091V518.068H647.353V509.883H637.511Z",
      "M576.532 519.889H634.278V506.703H647.287V450.727H650.523V515.264H647.306V518.248H644.089V515.031H647.287V509.92H637.495V519.889H640.872V523.105H573.314V450.727H576.532V519.889ZM644.09 521.541H640.873V518.324H644.09V521.541ZM650.523 450.725H573.315V447.508H650.523V450.725Z"
    ],
    "x": 611.9459999999999
  },
  {
    "y": 209.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1400.54 243.775H1451.67H1458.36V230.698H1471.36V174.883H1400.54V243.775Z",
      "M1461.51 233.883L1461.5 243.892H1464.87V245.285H1468.09V242.068H1471.35V233.883H1461.51Z",
      "M1400.53 243.889H1458.28V230.703H1471.29V174.727H1474.52V239.264H1471.31V242.248H1468.09V239.031H1471.29V233.92H1461.5V243.889H1464.87V247.105H1397.31V174.727H1400.53V243.889ZM1468.09 245.541H1464.87V242.324H1468.09V245.541ZM1474.52 174.725H1397.32V171.508H1474.52V174.725Z"
    ],
    "x": 1435.9499999999998
  },
  {
    "y": 606.329,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1692.04 640.775H1743.17H1749.86V627.698H1762.86V571.883H1692.04V640.775Z",
      "M1753.01 630.883L1753 640.892H1756.37V642.285H1759.59V639.068H1762.85V630.883H1753.01Z",
      "M1692.03 640.889H1749.78V627.703H1762.79V571.727H1766.02V636.264H1762.81V639.248H1759.59V636.031H1762.79V630.92H1753V640.889H1756.37V644.105H1688.81V571.727H1692.03V640.889ZM1759.59 642.541H1756.37V639.324H1759.59V642.541ZM1766.02 571.725H1688.82V568.508H1766.02V571.725Z"
    ],
    "x": 1727.4499999999998
  },
  {
    "y": 342.32899999999995,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1616.04 376.775H1667.17H1673.86V363.698H1686.86V307.883H1616.04V376.775Z",
      "M1677.01 366.883L1677 376.892H1680.37V378.285H1683.59V375.068H1686.85V366.883H1677.01Z",
      "M1616.03 376.889H1673.78V363.703H1686.79V307.727H1690.02V372.264H1686.81V375.248H1683.59V372.031H1686.79V366.92H1677V376.889H1680.37V380.105H1612.81V307.727H1616.03V376.889ZM1683.59 378.541H1680.37V375.324H1683.59V378.541ZM1690.02 307.725H1612.82V304.508H1690.02V307.725Z"
    ],
    "x": 1651.4499999999998
  },
  {
    "y": 342.32899999999995,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1576.04 376.775H1627.17H1633.86V363.698H1646.86V307.883H1576.04V376.775Z",
      "M1637.01 366.883L1637 376.892H1640.37V378.285H1643.59V375.068H1646.85V366.883H1637.01Z",
      "M1576.03 376.889H1633.78V363.703H1646.79V307.727H1650.02V372.264H1646.81V375.248H1643.59V372.031H1646.79V366.92H1637V376.889H1640.37V380.105H1572.81V307.727H1576.03V376.889ZM1643.59 378.541H1640.37V375.324H1643.59V378.541ZM1650.02 307.725H1572.82V304.508H1650.02V307.725Z"
    ],
    "x": 1611.4499999999998
  },
  {
    "y": 364.32899999999995,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M835.035 398.775H886.174H892.861V385.698H905.857V329.883H835.035V398.775Z",
      "M896.011 388.883L895.996 398.892H899.374V400.285H902.591V397.068H905.853V388.883H896.011Z",
      "M835.032 398.889H892.778V385.703H905.787V329.727H909.023V394.264H905.806V397.248H902.589V394.031H905.787V388.92H895.995V398.889H899.372V402.105H831.814V329.727H835.032V398.889ZM902.59 400.541H899.373V397.324H902.59V400.541ZM909.023 329.725H831.815V326.508H909.023V329.725Z"
    ],
    "x": 870.4459999999999
  },
  {
    "y": 507.32899999999995,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1216.54 541.775H1267.67H1274.36V528.698H1287.36V472.883H1216.54V541.775Z",
      "M1277.51 531.883L1277.5 541.892H1280.87V543.285H1284.09V540.068H1287.35V531.883H1277.51Z",
      "M1216.53 541.889H1274.28V528.703H1287.29V472.727H1290.52V537.264H1287.31V540.248H1284.09V537.031H1287.29V531.92H1277.5V541.889H1280.87V545.105H1213.31V472.727H1216.53V541.889ZM1284.09 543.541H1280.87V540.324H1284.09V543.541ZM1290.52 472.725H1213.32V469.508H1290.52V472.725Z"
    ],
    "x": 1251.9499999999998
  },
  {
    "y": 232.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1560.04 266.775H1611.17H1617.86V253.698H1630.86V197.883H1560.04V266.775Z",
      "M1621.01 256.883L1621 266.892H1624.37V268.285H1627.59V265.068H1630.85V256.883H1621.01Z",
      "M1560.03 266.889H1617.78V253.703H1630.79V197.727H1634.02V262.264H1630.81V265.248H1627.59V262.031H1630.79V256.92H1621V266.889H1624.37V270.105H1556.81V197.727H1560.03V266.889ZM1627.59 268.541H1624.37V265.324H1627.59V268.541ZM1634.02 197.725H1556.82V194.508H1634.02V197.725Z"
    ],
    "x": 1595.4499999999998
  },
  {
    "y": 526.598,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M402.807 561.044H453.945H460.633V547.968H473.629V492.152H402.807V561.044Z",
      "M463.782 551.152L463.768 561.162H467.145V562.554H470.362V559.337H473.624V551.152H463.782Z",
      "M402.804 561.158H460.55V547.973H473.559V491.996H476.795V556.533H473.577V559.518H470.36V556.301H473.559V551.189H463.767V561.158H467.144V564.375H399.586V491.996H402.804V561.158ZM470.361 562.811H467.145V559.594H470.361V562.811ZM476.795 491.994H399.587V488.777H476.795V491.994Z"
    ],
    "x": 438.218
  },
  {
    "y": 526.598,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M462.807 561.044H513.945H520.633V547.968H533.629V492.152H462.807V561.044Z",
      "M523.782 551.152L523.768 561.162H527.145V562.554H530.362V559.337H533.624V551.152H523.782Z",
      "M462.804 561.158H520.55V547.973H533.559V491.996H536.795V556.533H533.577V559.518H530.36V556.301H533.559V551.189H523.767V561.158H527.144V564.375H459.586V491.996H462.804V561.158ZM530.361 562.811H527.145V559.594H530.361V562.811ZM536.795 491.994H459.587V488.777H536.795V491.994Z"
    ],
    "x": 498.218
  },
  {
    "y": 485.32899999999995,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1681.54 519.775H1732.67H1739.36V506.698H1752.36V450.883H1681.54V519.775Z",
      "M1742.51 509.883L1742.5 519.892H1745.87V521.285H1749.09V518.068H1752.35V509.883H1742.51Z",
      "M1681.53 519.889H1739.28V506.703H1752.29V450.727H1755.52V515.264H1752.31V518.248H1749.09V515.031H1752.29V509.92H1742.5V519.889H1745.87V523.105H1678.31V450.727H1681.53V519.889ZM1749.09 521.541H1745.87V518.324H1749.09V521.541ZM1755.52 450.725H1678.32V447.508H1755.52V450.725Z"
    ],
    "x": 1716.9499999999998
  },
  {
    "y": 279.329,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M686.535 313.775H737.674H744.361V300.698H757.357V244.883H686.535V313.775Z",
      "M747.511 303.883L747.496 313.892H750.874V315.285H754.091V312.068H757.353V303.883H747.511Z",
      "M686.532 313.889H744.278V300.703H757.287V244.727H760.523V309.264H757.306V312.248H754.089V309.031H757.287V303.92H747.495V313.889H750.872V317.105H683.314V244.727H686.532V313.889ZM754.09 315.541H750.873V312.324H754.09V315.541ZM760.523 244.725H683.315V241.508H760.523V244.725Z"
    ],
    "x": 721.9459999999999
  },
  {
    "y": 322.59799999999996,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M683.807 357.044H734.945H741.633V343.968H754.629V288.152H683.807V357.044Z",
      "M744.782 347.152L744.768 357.162H748.145V358.554H751.362V355.337H754.624V347.152H744.782Z",
      "M683.804 357.158H741.55V343.973H754.559V287.996H757.795V352.533H754.577V355.518H751.36V352.301H754.559V347.189H744.767V357.158H748.144V360.375H680.586V287.996H683.804V357.158ZM751.361 358.811H748.145V355.594H751.361V358.811ZM757.795 287.994H680.587V284.777H757.795V287.994Z"
    ],
    "x": 719.2180000000001
  },
  {
    "y": 671.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M851.535 705.775H902.674H909.361V692.698H922.357V636.883H851.535V705.775Z",
      "M912.511 695.883L912.496 705.892H915.874V707.285H919.091V704.068H922.353V695.883H912.511Z",
      "M851.532 705.889H909.278V692.703H922.287V636.727H925.523V701.264H922.306V704.248H919.089V701.031H922.287V695.92H912.495V705.889H915.872V709.105H848.314V636.727H851.532V705.889ZM919.09 707.541H915.873V704.324H919.09V707.541ZM925.523 636.725H848.315V633.508H925.523V636.725Z"
    ],
    "x": 886.9459999999999
  },
  {
    "y": 621.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M831.535 655.775H882.674H889.361V642.698H902.357V586.883H831.535V655.775Z",
      "M892.511 645.883L892.496 655.892H895.874V657.285H899.091V654.068H902.353V645.883H892.511Z",
      "M831.532 655.889H889.278V642.703H902.287V586.727H905.523V651.264H902.306V654.248H899.089V651.031H902.287V645.92H892.495V655.889H895.872V659.105H828.314V586.727H831.532V655.889ZM899.09 657.541H895.873V654.324H899.09V657.541ZM905.523 586.725H828.315V583.508H905.523V586.725Z"
    ],
    "x": 866.9459999999999
  },
  {
    "y": 430.32899999999995,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M719.035 464.775H770.174H776.861V451.698H789.857V395.883H719.035V464.775Z",
      "M780.011 454.883L779.996 464.892H783.374V466.285H786.591V463.068H789.853V454.883H780.011Z",
      "M719.032 464.889H776.778V451.703H789.787V395.727H793.023V460.264H789.806V463.248H786.589V460.031H789.787V454.92H779.995V464.889H783.372V468.105H715.814V395.727H719.032V464.889ZM786.59 466.541H783.373V463.324H786.59V466.541ZM793.023 395.725H715.815V392.508H793.023V395.725Z"
    ],
    "x": 754.4459999999999
  },
  {
    "y": 504.59799999999996,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M864.807 539.044H915.945H922.633V525.968H935.629V470.152H864.807V539.044Z",
      "M925.782 529.152L925.768 539.162H929.145V540.554H932.362V537.337H935.624V529.152H925.782Z",
      "M864.804 539.158H922.55V525.973H935.559V469.996H938.795V534.533H935.577V537.518H932.36V534.301H935.559V529.189H925.767V539.158H929.144V542.375H861.586V469.996H864.804V539.158ZM932.361 540.811H929.145V537.594H932.361V540.811ZM938.795 469.994H861.587V466.777H938.795V469.994Z"
    ],
    "x": 900.2180000000001
  },
  {
    "y": 530.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M264.035 564.775H315.174H321.861V551.698H334.857V495.883H264.035V564.775Z",
      "M325.011 554.883L324.996 564.892H328.374V566.285H331.591V563.068H334.853V554.883H325.011Z",
      "M264.032 564.889H321.778V551.703H334.787V495.727H338.023V560.264H334.806V563.248H331.589V560.031H334.787V554.92H324.995V564.889H328.372V568.105H260.814V495.727H264.032V564.889ZM331.59 566.541H328.373V563.324H331.59V566.541ZM338.023 495.725H260.815V492.508H338.023V495.725Z"
    ],
    "x": 299.446
  },
  {
    "y": 661.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M642.535 695.775H693.674H700.361V682.698H713.357V626.883H642.535V695.775Z",
      "M703.511 685.883L703.496 695.892H706.874V697.285H710.091V694.068H713.353V685.883H703.511Z",
      "M642.532 695.889H700.278V682.703H713.287V626.727H716.523V691.264H713.306V694.248H710.089V691.031H713.287V685.92H703.495V695.889H706.872V699.105H639.314V626.727H642.532V695.889ZM710.09 697.541H706.873V694.324H710.09V697.541ZM716.523 626.725H639.315V623.508H716.523V626.725Z"
    ],
    "x": 677.9459999999999
  },
  {
    "y": 701.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M642.535 735.775H693.674H700.361V722.698H713.357V666.883H642.535V735.775Z",
      "M703.511 725.883L703.496 735.892H706.874V737.285H710.091V734.068H713.353V725.883H703.511Z",
      "M642.532 735.889H700.278V722.703H713.287V666.727H716.523V731.264H713.306V734.248H710.089V731.031H713.287V725.92H703.495V735.889H706.872V739.105H639.314V666.727H642.532V735.889ZM710.09 737.541H706.873V734.324H710.09V737.541ZM716.523 666.725H639.315V663.508H716.523V666.725Z"
    ],
    "x": 677.9459999999999
  },
  {
    "y": 330.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M956.035 364.775H1007.17H1013.86V351.698H1026.86V295.883H956.035V364.775Z",
      "M1017.01 354.883L1017 364.892H1020.37V366.285H1023.59V363.068H1026.85V354.883H1017.01Z",
      "M956.032 364.889H1013.78V351.703H1026.79V295.727H1030.02V360.264H1026.81V363.248H1023.59V360.031H1026.79V354.92H1017V364.889H1020.37V368.105H952.814V295.727H956.032V364.889ZM1023.59 366.541H1020.37V363.324H1023.59V366.541ZM1030.02 295.725H952.815V292.508H1030.02V295.725Z"
    ],
    "x": 991.4475
  },
  {
    "y": 308.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M944.035 342.775H995.174H1001.86V329.698H1014.86V273.883H944.035V342.775Z",
      "M1005.01 332.883L1005 342.892H1008.37V344.285H1011.59V341.068H1014.85V332.883H1005.01Z",
      "M944.032 342.889H1001.78V329.703H1014.79V273.727H1018.02V338.264H1014.81V341.248H1011.59V338.031H1014.79V332.92H1005V342.889H1008.37V346.105H940.814V273.727H944.032V342.889ZM1011.59 344.541H1008.37V341.324H1011.59V344.541ZM1018.02 273.725H940.815V270.508H1018.02V273.725Z"
    ],
    "x": 979.4475
  },
  {
    "y": 419.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1501.54 453.775H1552.67H1559.36V440.698H1572.36V384.883H1501.54V453.775Z",
      "M1562.51 443.883L1562.5 453.892H1565.87V455.285H1569.09V452.068H1572.35V443.883H1562.51Z",
      "M1501.53 453.889H1559.28V440.703H1572.29V384.727H1575.52V449.264H1572.31V452.248H1569.09V449.031H1572.29V443.92H1562.5V453.889H1565.87V457.105H1498.31V384.727H1501.53V453.889ZM1569.09 455.541H1565.87V452.324H1569.09V455.541ZM1575.52 384.725H1498.32V381.508H1575.52V384.725Z"
    ],
    "x": 1536.9499999999998
  },
  {
    "y": 449.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1532.54 483.775H1583.67H1590.36V470.698H1603.36V414.883H1532.54V483.775Z",
      "M1593.51 473.883L1593.5 483.892H1596.87V485.285H1600.09V482.068H1603.35V473.883H1593.51Z",
      "M1532.53 483.889H1590.28V470.703H1603.29V414.727H1606.52V479.264H1603.31V482.248H1600.09V479.031H1603.29V473.92H1593.5V483.889H1596.87V487.105H1529.31V414.727H1532.53V483.889ZM1600.09 485.541H1596.87V482.324H1600.09V485.541ZM1606.52 414.725H1529.32V411.508H1606.52V414.725Z"
    ],
    "x": 1567.9499999999998
  },
  {
    "y": 540.329,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M736.035 574.775H787.174H793.861V561.698H806.857V505.883H736.035V574.775Z",
      "M797.011 564.883L796.996 574.892H800.374V576.285H803.591V573.068H806.853V564.883H797.011Z",
      "M736.032 574.889H793.778V561.703H806.787V505.727H810.023V570.264H806.806V573.248H803.589V570.031H806.787V564.92H796.995V574.889H800.372V578.105H732.814V505.727H736.032V574.889ZM803.59 576.541H800.373V573.324H803.59V576.541ZM810.023 505.725H732.815V502.508H810.023V505.725Z"
    ],
    "x": 771.4459999999999
  },
  {
    "y": 200.598,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M870.807 235.044H921.945H928.633V221.968H941.629V166.152H870.807V235.044Z",
      "M931.782 225.152L931.768 235.162H935.145V236.554H938.362V233.337H941.624V225.152H931.782Z",
      "M870.804 235.158H928.55V221.973H941.559V165.996H944.795V230.533H941.577V233.518H938.36V230.301H941.559V225.189H931.767V235.158H935.144V238.375H867.586V165.996H870.804V235.158ZM938.361 236.811H935.145V233.594H938.361V236.811ZM944.795 165.994H867.587V162.777H944.795V165.994Z"
    ],
    "x": 906.2180000000001
  },
  {
    "y": 167.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1192.54 201.775H1243.67H1250.36V188.698H1263.36V132.883H1192.54V201.775Z",
      "M1253.51 191.883L1253.5 201.892H1256.87V203.285H1260.09V200.068H1263.35V191.883H1253.51Z",
      "M1192.53 201.889H1250.28V188.703H1263.29V132.727H1266.52V197.264H1263.31V200.248H1260.09V197.031H1263.29V191.92H1253.5V201.889H1256.87V205.105H1189.31V132.727H1192.53V201.889ZM1260.09 203.541H1256.87V200.324H1260.09V203.541ZM1266.52 132.725H1189.32V129.508H1266.52V132.725Z"
    ],
    "x": 1227.9499999999998
  },
  {
    "y": 419.32899999999995,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M422.535 453.775H473.674H480.361V440.698H493.357V384.883H422.535V453.775Z",
      "M483.511 443.883L483.496 453.892H486.874V455.285H490.091V452.068H493.353V443.883H483.511Z",
      "M422.532 453.889H480.278V440.703H493.287V384.727H496.523V449.264H493.306V452.248H490.089V449.031H493.287V443.92H483.495V453.889H486.872V457.105H419.314V384.727H422.532V453.889ZM490.09 455.541H486.873V452.324H490.09V455.541ZM496.523 384.725H419.315V381.508H496.523V384.725Z"
    ],
    "x": 457.946
  },
  {
    "y": 400.59799999999996,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M411.807 435.044H462.945H469.633V421.968H482.629V366.152H411.807V435.044Z",
      "M472.782 425.152L472.768 435.162H476.145V436.554H479.362V433.337H482.624V425.152H472.782Z",
      "M411.804 435.158H469.55V421.973H482.559V365.996H485.795V430.533H482.577V433.518H479.36V430.301H482.559V425.189H472.767V435.158H476.144V438.375H408.586V365.996H411.804V435.158ZM479.361 436.811H476.145V433.594H479.361V436.811ZM485.795 365.994H408.587V362.777H485.795V365.994Z"
    ],
    "x": 447.218
  },
  {
    "y": 459.32899999999995,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M462.535 493.775H513.674H520.361V480.698H533.357V424.883H462.535V493.775Z",
      "M523.511 483.883L523.496 493.892H526.874V495.285H530.091V492.068H533.353V483.883H523.511Z",
      "M462.532 493.889H520.278V480.703H533.287V424.727H536.523V489.264H533.306V492.248H530.089V489.031H533.287V483.92H523.495V493.889H526.872V497.105H459.314V424.727H462.532V493.889ZM530.09 495.541H526.873V492.324H530.09V495.541ZM536.523 424.725H459.315V421.508H536.523V424.725Z"
    ],
    "x": 497.946
  },
  {
    "y": 440.59799999999996,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M451.807 475.044H502.945H509.633V461.968H522.629V406.152H451.807V475.044Z",
      "M512.782 465.152L512.768 475.162H516.145V476.554H519.362V473.337H522.624V465.152H512.782Z",
      "M451.804 475.158H509.55V461.973H522.559V405.996H525.795V470.533H522.577V473.518H519.36V470.301H522.559V465.189H512.767V475.158H516.144V478.375H448.586V405.996H451.804V475.158ZM519.361 476.811H516.145V473.594H519.361V476.811ZM525.795 405.994H448.587V402.777H525.795V405.994Z"
    ],
    "x": 487.218
  },
  {
    "y": 546.598,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M122.807 581.044H173.945H180.633V567.968H193.629V512.152H122.807V581.044Z",
      "M183.782 571.152L183.768 581.162H187.145V582.554H190.362V579.337H193.624V571.152H183.782Z",
      "M122.804 581.158H180.55V567.973H193.559V511.996H196.795V576.533H193.577V579.518H190.36V576.301H193.559V571.189H183.767V581.158H187.144V584.375H119.586V511.996H122.804V581.158ZM190.361 582.811H187.145V579.594H190.361V582.811ZM196.795 511.994H119.587V508.777H196.795V511.994Z"
    ],
    "x": 158.218
  },
  {
    "y": 661.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M771.535 695.775H822.674H829.361V682.698H842.357V626.883H771.535V695.775Z",
      "M832.511 685.883L832.496 695.892H835.874V697.285H839.091V694.068H842.353V685.883H832.511Z",
      "M771.532 695.889H829.278V682.703H842.287V626.727H845.523V691.264H842.306V694.248H839.089V691.031H842.287V685.92H832.495V695.889H835.872V699.105H768.314V626.727H771.532V695.889ZM839.09 697.541H835.873V694.324H839.09V697.541ZM845.523 626.725H768.315V623.508H845.523V626.725Z"
    ],
    "x": 806.9459999999999
  },
  {
    "y": 478.32899999999995,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1555.54 512.775H1606.67H1613.36V499.698H1626.36V443.883H1555.54V512.775Z",
      "M1616.51 502.883L1616.5 512.892H1619.87V514.285H1623.09V511.068H1626.35V502.883H1616.51Z",
      "M1555.53 512.889H1613.28V499.703H1626.29V443.727H1629.52V508.264H1626.31V511.248H1623.09V508.031H1626.29V502.92H1616.5V512.889H1619.87V516.105H1552.31V443.727H1555.53V512.889ZM1623.09 514.541H1619.87V511.324H1623.09V514.541ZM1629.52 443.725H1552.32V440.508H1629.52V443.725Z"
    ],
    "x": 1590.9499999999998
  },
  {
    "y": 668.598,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1126.81 703.044H1177.95H1184.63V689.968H1197.63V634.152H1126.81V703.044Z",
      "M1187.78 693.152L1187.77 703.162H1191.15V704.554H1194.36V701.337H1197.62V693.152H1187.78Z",
      "M1126.8 703.158H1184.55V689.973H1197.56V633.996H1200.79V698.533H1197.58V701.518H1194.36V698.301H1197.56V693.189H1187.77V703.158H1191.14V706.375H1123.59V633.996H1126.8V703.158ZM1194.36 704.811H1191.14V701.594H1194.36V704.811ZM1200.79 633.994H1123.59V630.777H1200.79V633.994Z"
    ],
    "x": 1162.22
  },
  {
    "y": 472.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1395.04 506.775H1446.17H1452.86V493.698H1465.86V437.883H1395.04V506.775Z",
      "M1456.01 496.883L1456 506.892H1459.37V508.285H1462.59V505.068H1465.85V496.883H1456.01Z",
      "M1395.03 506.889H1452.78V493.703H1465.79V437.727H1469.02V502.264H1465.81V505.248H1462.59V502.031H1465.79V496.92H1456V506.889H1459.37V510.105H1391.81V437.727H1395.03V506.889ZM1462.59 508.541H1459.37V505.324H1462.59V508.541ZM1469.02 437.725H1391.82V434.508H1469.02V437.725Z"
    ],
    "x": 1430.4499999999998
  },
  {
    "y": 661.329,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M532.535 695.775H583.674H590.361V682.698H603.357V626.883H532.535V695.775Z",
      "M593.511 685.883L593.496 695.892H596.874V697.285H600.091V694.068H603.353V685.883H593.511Z",
      "M532.532 695.889H590.278V682.703H603.287V626.727H606.523V691.264H603.306V694.248H600.089V691.031H603.287V685.92H593.495V695.889H596.872V699.105H529.314V626.727H532.532V695.889ZM600.09 697.541H596.873V694.324H600.09V697.541ZM606.523 626.725H529.315V623.508H606.523V626.725Z"
    ],
    "x": 567.9459999999999
  },
  {
    "y": 177.329,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1027.54 211.775H1078.67H1085.36V198.698H1098.36V142.883H1027.54V211.775Z",
      "M1088.51 201.883L1088.5 211.892H1091.87V213.285H1095.09V210.068H1098.35V201.883H1088.51Z",
      "M1027.53 211.889H1085.28V198.703H1098.29V142.727H1101.52V207.264H1098.31V210.248H1095.09V207.031H1098.29V201.92H1088.5V211.889H1091.87V215.105H1024.31V142.727H1027.53V211.889ZM1095.09 213.541H1091.87V210.324H1095.09V213.541ZM1101.52 142.725H1024.32V139.508H1101.52V142.725Z"
    ],
    "x": 1062.9499999999998
  },
  {
    "y": 474.32899999999995,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1011.04 508.775H1062.17H1068.86V495.698H1081.86V439.883H1011.04V508.775Z",
      "M1072.01 498.883L1072 508.892H1075.37V510.285H1078.59V507.068H1081.85V498.883H1072.01Z",
      "M1011.03 508.889H1068.78V495.703H1081.79V439.727H1085.02V504.264H1081.81V507.248H1078.59V504.031H1081.79V498.92H1072V508.889H1075.37V512.105H1007.81V439.727H1011.03V508.889ZM1078.59 510.541H1075.37V507.324H1078.59V510.541ZM1085.02 439.725H1007.82V436.508H1085.02V439.725Z"
    ],
    "x": 1046.4499999999998
  },
  {
    "y": 309.32899999999995,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1445.54 343.775H1496.67H1503.36V330.698H1516.36V274.883H1445.54V343.775Z",
      "M1506.51 333.883L1506.5 343.892H1509.87V345.285H1513.09V342.068H1516.35V333.883H1506.51Z",
      "M1445.53 343.889H1503.28V330.703H1516.29V274.727H1519.52V339.264H1516.31V342.248H1513.09V339.031H1516.29V333.92H1506.5V343.889H1509.87V347.105H1442.31V274.727H1445.53V343.889ZM1513.09 345.541H1509.87V342.324H1513.09V345.541ZM1519.52 274.725H1442.32V271.508H1519.52V274.725Z"
    ],
    "x": 1480.9499999999998
  },
  {
    "y": 604.329,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M506.035 638.775H557.174H563.861V625.698H576.857V569.883H506.035V638.775Z",
      "M567.011 628.883L566.996 638.892H570.374V640.285H573.591V637.068H576.853V628.883H567.011Z",
      "M506.032 638.889H563.778V625.703H576.787V569.727H580.023V634.264H576.806V637.248H573.589V634.031H576.787V628.92H566.995V638.889H570.372V642.105H502.814V569.727H506.032V638.889ZM573.59 640.541H570.373V637.324H573.59V640.541ZM580.023 569.725H502.815V566.508H580.023V569.725Z"
    ],
    "x": 541.446
  },
  {
    "y": 584.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1242.04 618.775H1293.17H1299.86V605.698H1312.86V549.883H1242.04V618.775Z",
      "M1303.01 608.883L1303 618.892H1306.37V620.285H1309.59V617.068H1312.85V608.883H1303.01Z",
      "M1242.03 618.889H1299.78V605.703H1312.79V549.727H1316.02V614.264H1312.81V617.248H1309.59V614.031H1312.79V608.92H1303V618.889H1306.37V622.105H1238.81V549.727H1242.03V618.889ZM1309.59 620.541H1306.37V617.324H1309.59V620.541ZM1316.02 549.725H1238.82V546.508H1316.02V549.725Z"
    ],
    "x": 1277.4499999999998
  },
  {
    "y": 597.598,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1103.81 632.044H1154.95H1161.63V618.968H1174.63V563.152H1103.81V632.044Z",
      "M1164.78 622.152L1164.77 632.162H1168.15V633.554H1171.36V630.337H1174.62V622.152H1164.78Z",
      "M1103.8 632.158H1161.55V618.973H1174.56V562.996H1177.79V627.533H1174.58V630.518H1171.36V627.301H1174.56V622.189H1164.77V632.158H1168.14V635.375H1100.59V562.996H1103.8V632.158ZM1171.36 633.811H1168.14V630.594H1171.36V633.811ZM1177.79 562.994H1100.59V559.777H1177.79V562.994Z"
    ],
    "x": 1139.22
  },
  {
    "y": 641.8679999999999,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1054.08 676.314H1105.22H1111.9V663.237H1124.9V607.422H1054.08V676.314Z",
      "M1115.05 666.422L1115.04 676.431H1118.42V677.824H1121.63V674.607H1124.9V666.422H1115.05Z",
      "M1054.08 676.428H1111.82V663.242H1124.83V607.266H1128.07V671.803H1124.85V674.787H1121.63V671.57H1124.83V666.459H1115.04V676.428H1118.42V679.645H1050.86V607.266H1054.08V676.428ZM1121.63 678.08H1118.42V674.863H1121.63V678.08ZM1128.07 607.264H1050.86V604.047H1128.07V607.264Z"
    ],
    "x": 1089.49
  },
  {
    "y": 593.329,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M642.535 627.775H693.674H700.361V614.698H713.357V558.883H642.535V627.775Z",
      "M703.511 617.883L703.496 627.892H706.874V629.285H710.091V626.068H713.353V617.883H703.511Z",
      "M642.532 627.889H700.278V614.703H713.287V558.727H716.523V623.264H713.306V626.248H710.089V623.031H713.287V617.92H703.495V627.889H706.872V631.105H639.314V558.727H642.532V627.889ZM710.09 629.541H706.873V626.324H710.09V629.541ZM716.523 558.725H639.315V555.508H716.523V558.725Z"
    ],
    "x": 677.9459999999999
  },
  {
    "y": 672.329,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1198.04 706.775H1249.17H1255.86V693.698H1268.86V637.883H1198.04V706.775Z",
      "M1259.01 696.883L1259 706.892H1262.37V708.285H1265.59V705.068H1268.85V696.883H1259.01Z",
      "M1198.03 706.889H1255.78V693.703H1268.79V637.727H1272.02V702.264H1268.81V705.248H1265.59V702.031H1268.79V696.92H1259V706.889H1262.37V710.105H1194.81V637.727H1198.03V706.889ZM1265.59 708.541H1262.37V705.324H1265.59V708.541ZM1272.02 637.725H1194.82V634.508H1272.02V637.725Z"
    ],
    "x": 1233.4499999999998
  },
  {
    "y": 409.32899999999995,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M341.535 443.775H392.674H399.361V430.698H412.357V374.883H341.535V443.775Z",
      "M402.511 433.883L402.496 443.892H405.874V445.285H409.091V442.068H412.353V433.883H402.511Z",
      "M341.532 443.889H399.278V430.703H412.287V374.727H415.523V439.264H412.306V442.248H409.089V439.031H412.287V433.92H402.495V443.889H405.872V447.105H338.314V374.727H341.532V443.889ZM409.09 445.541H405.873V442.324H409.09V445.541ZM415.523 374.725H338.315V371.508H415.523V374.725Z"
    ],
    "x": 376.946
  },
  {
    "y": 166.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1264.04 200.775H1315.17H1321.86V187.698H1334.86V131.883H1264.04V200.775Z",
      "M1325.01 190.883L1325 200.892H1328.37V202.285H1331.59V199.068H1334.85V190.883H1325.01Z",
      "M1264.03 200.889H1321.78V187.703H1334.79V131.727H1338.02V196.264H1334.81V199.248H1331.59V196.031H1334.79V190.92H1325V200.889H1328.37V204.105H1260.81V131.727H1264.03V200.889ZM1331.59 202.541H1328.37V199.324H1331.59V202.541ZM1338.02 131.725H1260.82V128.508H1338.02V131.725Z"
    ],
    "x": 1299.4499999999998
  },
  {
    "y": 375.32899999999995,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M917.535 409.775H968.674H975.361V396.698H988.357V340.883H917.535V409.775Z",
      "M978.511 399.883L978.496 409.892H981.874V411.285H985.091V408.068H988.353V399.883H978.511Z",
      "M917.532 409.889H975.278V396.703H988.287V340.727H991.523V405.264H988.306V408.248H985.089V405.031H988.287V399.92H978.495V409.889H981.872V413.105H914.314V340.727H917.532V409.889ZM985.09 411.541H981.873V408.324H985.09V411.541ZM991.523 340.725H914.315V337.508H991.523V340.725Z"
    ],
    "x": 952.9459999999999
  },
  {
    "y": 565.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1456.54 599.775H1507.67H1514.36V586.698H1527.36V530.883H1456.54V599.775Z",
      "M1517.51 589.883L1517.5 599.892H1520.87V601.285H1524.09V598.068H1527.35V589.883H1517.51Z",
      "M1456.53 599.889H1514.28V586.703H1527.29V530.727H1530.52V595.264H1527.31V598.248H1524.09V595.031H1527.29V589.92H1517.5V599.889H1520.87V603.105H1453.31V530.727H1456.53V599.889ZM1524.09 601.541H1520.87V598.324H1524.09V601.541ZM1530.52 530.725H1453.32V527.508H1530.52V530.725Z"
    ],
    "x": 1491.9499999999998
  },
  {
    "y": 666.598,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M985.807 701.044H1036.95H1043.63V687.968H1056.63V632.152H985.807V701.044Z",
      "M1046.78 691.152L1046.77 701.162H1050.15V702.554H1053.36V699.337H1056.62V691.152H1046.78Z",
      "M985.804 701.158H1043.55V687.973H1056.56V631.996H1059.79V696.533H1056.58V699.518H1053.36V696.301H1056.56V691.189H1046.77V701.158H1050.14V704.375H982.586V631.996H985.804V701.158ZM1053.36 702.811H1050.14V699.594H1053.36V702.811ZM1059.79 631.994H982.587V628.777H1059.79V631.994Z"
    ],
    "x": 1021.2185000000001
  },
  {
    "y": 177.329,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1456.54 211.775H1507.67H1514.36V198.698H1527.36V142.883H1456.54V211.775Z",
      "M1517.51 201.883L1517.5 211.892H1520.87V213.285H1524.09V210.068H1527.35V201.883H1517.51Z",
      "M1456.53 211.889H1514.28V198.703H1527.29V142.727H1530.52V207.264H1527.31V210.248H1524.09V207.031H1527.29V201.92H1517.5V211.889H1520.87V215.105H1453.31V142.727H1456.53V211.889ZM1524.09 213.541H1520.87V210.324H1524.09V213.541ZM1530.52 142.725H1453.32V139.508H1530.52V142.725Z"
    ],
    "x": 1491.9499999999998
  },
  {
    "y": 276.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1110.04 310.775H1161.17H1167.86V297.698H1180.86V241.883H1110.04V310.775Z",
      "M1171.01 300.883L1171 310.892H1174.37V312.285H1177.59V309.068H1180.85V300.883H1171.01Z",
      "M1110.03 310.889H1167.78V297.703H1180.79V241.727H1184.02V306.264H1180.81V309.248H1177.59V306.031H1180.79V300.92H1171V310.889H1174.37V314.105H1106.81V241.727H1110.03V310.889ZM1177.59 312.541H1174.37V309.324H1177.59V312.541ZM1184.02 241.725H1106.82V238.508H1184.02V241.725Z"
    ],
    "x": 1145.4499999999998
  },
  {
    "y": 496.32899999999995,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1319.04 530.775H1370.17H1376.86V517.698H1389.86V461.883H1319.04V530.775Z",
      "M1380.01 520.883L1380 530.892H1383.37V532.285H1386.59V529.068H1389.85V520.883H1380.01Z",
      "M1319.03 530.889H1376.78V517.703H1389.79V461.727H1393.02V526.264H1389.81V529.248H1386.59V526.031H1389.79V520.92H1380V530.889H1383.37V534.105H1315.81V461.727H1319.03V530.889ZM1386.59 532.541H1383.37V529.324H1386.59V532.541ZM1393.02 461.725H1315.82V458.508H1393.02V461.725Z"
    ],
    "x": 1354.4499999999998
  },
  {
    "y": 516.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1259.04 550.775H1310.17H1316.86V537.698H1329.86V481.883H1259.04V550.775Z",
      "M1320.01 540.883L1320 550.892H1323.37V552.285H1326.59V549.068H1329.85V540.883H1320.01Z",
      "M1259.03 550.889H1316.78V537.703H1329.79V481.727H1333.02V546.264H1329.81V549.248H1326.59V546.031H1329.79V540.92H1320V550.889H1323.37V554.105H1255.81V481.727H1259.03V550.889ZM1326.59 552.541H1323.37V549.324H1326.59V552.541ZM1333.02 481.725H1255.82V478.508H1333.02V481.725Z"
    ],
    "x": 1294.4499999999998
  },
  {
    "y": 243.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1038.54 277.775H1089.67H1096.36V264.698H1109.36V208.883H1038.54V277.775Z",
      "M1099.51 267.883L1099.5 277.892H1102.87V279.285H1106.09V276.068H1109.35V267.883H1099.51Z",
      "M1038.53 277.889H1096.28V264.703H1109.29V208.727H1112.52V273.264H1109.31V276.248H1106.09V273.031H1109.29V267.92H1099.5V277.889H1102.87V281.105H1035.31V208.727H1038.53V277.889ZM1106.09 279.541H1102.87V276.324H1106.09V279.541ZM1112.52 208.725H1035.32V205.508H1112.52V208.725Z"
    ],
    "x": 1073.9499999999998
  },
  {
    "y": 320.32899999999995,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1198.04 354.775H1249.17H1255.86V341.698H1268.86V285.883H1198.04V354.775Z",
      "M1259.01 344.883L1259 354.892H1262.37V356.285H1265.59V353.068H1268.85V344.883H1259.01Z",
      "M1198.03 354.889H1255.78V341.703H1268.79V285.727H1272.02V350.264H1268.81V353.248H1265.59V350.031H1268.79V344.92H1259V354.889H1262.37V358.105H1194.81V285.727H1198.03V354.889ZM1265.59 356.541H1262.37V353.324H1265.59V356.541ZM1272.02 285.725H1194.82V282.508H1272.02V285.725Z"
    ],
    "x": 1233.4499999999998
  },
  {
    "y": 364.32899999999995,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1330.04 398.775H1381.17H1387.86V385.698H1400.86V329.883H1330.04V398.775Z",
      "M1391.01 388.883L1391 398.892H1394.37V400.285H1397.59V397.068H1400.85V388.883H1391.01Z",
      "M1330.03 398.889H1387.78V385.703H1400.79V329.727H1404.02V394.264H1400.81V397.248H1397.59V394.031H1400.79V388.92H1391V398.889H1394.37V402.105H1326.81V329.727H1330.03V398.889ZM1397.59 400.541H1394.37V397.324H1397.59V400.541ZM1404.02 329.725H1326.82V326.508H1404.02V329.725Z"
    ],
    "x": 1365.4499999999998
  },
  {
    "y": 397.32899999999995,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1269.54 431.775H1320.67H1327.36V418.698H1340.36V362.883H1269.54V431.775Z",
      "M1330.51 421.883L1330.5 431.892H1333.87V433.285H1337.09V430.068H1340.35V421.883H1330.51Z",
      "M1269.53 431.889H1327.28V418.703H1340.29V362.727H1343.52V427.264H1340.31V430.248H1337.09V427.031H1340.29V421.92H1330.5V431.889H1333.87V435.105H1266.31V362.727H1269.53V431.889ZM1337.09 433.541H1333.87V430.324H1337.09V433.541ZM1343.52 362.725H1266.32V359.508H1343.52V362.725Z"
    ],
    "x": 1304.9499999999998
  },
  {
    "y": 316.59799999999996,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M611.807 351.044H662.945H669.633V337.968H682.629V282.152H611.807V351.044Z",
      "M672.782 341.152L672.768 351.162H676.145V352.554H679.362V349.337H682.624V341.152H672.782Z",
      "M611.804 351.158H669.55V337.973H682.559V281.996H685.795V346.533H682.577V349.518H679.36V346.301H682.559V341.189H672.767V351.158H676.144V354.375H608.586V281.996H611.804V351.158ZM679.361 352.811H676.145V349.594H679.361V352.811ZM685.795 281.994H608.587V278.777H685.795V281.994Z"
    ],
    "x": 647.2180000000001
  },
  {
    "y": 355.32899999999995,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M554.535 389.775H605.674H612.361V376.698H625.357V320.883H554.535V389.775Z",
      "M615.511 379.883L615.496 389.892H618.874V391.285H622.091V388.068H625.353V379.883H615.511Z",
      "M554.532 389.889H612.278V376.703H625.287V320.727H628.523V385.264H625.306V388.248H622.089V385.031H625.287V379.92H615.495V389.889H618.872V393.105H551.314V320.727H554.532V389.889ZM622.09 391.541H618.873V388.324H622.09V391.541ZM628.523 320.725H551.315V317.508H628.523V320.725Z"
    ],
    "x": 589.9459999999999
  },
  {
    "y": 298.32899999999995,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1572.04 332.775H1623.17H1629.86V319.698H1642.86V263.883H1572.04V332.775Z",
      "M1633.01 322.883L1633 332.892H1636.37V334.285H1639.59V331.068H1642.85V322.883H1633.01Z",
      "M1572.03 332.889H1629.78V319.703H1642.79V263.727H1646.02V328.264H1642.81V331.248H1639.59V328.031H1642.79V322.92H1633V332.889H1636.37V336.105H1568.81V263.727H1572.03V332.889ZM1639.59 334.541H1636.37V331.324H1639.59V334.541ZM1646.02 263.725H1568.82V260.508H1646.02V263.725Z"
    ],
    "x": 1607.4499999999998
  },
  {
    "y": 386.32899999999995,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1660.04 420.775H1711.17H1717.86V407.698H1730.86V351.883H1660.04V420.775Z",
      "M1721.01 410.883L1721 420.892H1724.37V422.285H1727.59V419.068H1730.85V410.883H1721.01Z",
      "M1660.03 420.889H1717.78V407.703H1730.79V351.727H1734.02V416.264H1730.81V419.248H1727.59V416.031H1730.79V410.92H1721V420.889H1724.37V424.105H1656.81V351.727H1660.03V420.889ZM1727.59 422.541H1724.37V419.324H1727.59V422.541ZM1734.02 351.725H1656.82V348.508H1734.02V351.725Z"
    ],
    "x": 1695.4499999999998
  },
  {
    "y": 408.32899999999995,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M791.035 442.775H842.174H848.861V429.698H861.857V373.883H791.035V442.775Z",
      "M852.011 432.883L851.996 442.892H855.374V444.285H858.591V441.068H861.853V432.883H852.011Z",
      "M791.032 442.889H848.778V429.703H861.787V373.727H865.023V438.264H861.806V441.248H858.589V438.031H861.787V432.92H851.995V442.889H855.372V446.105H787.814V373.727H791.032V442.889ZM858.59 444.541H855.373V441.324H858.59V444.541ZM865.023 373.725H787.815V370.508H865.023V373.725Z"
    ],
    "x": 826.4459999999999
  },
  {
    "y": 430.32899999999995,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M175.035 464.775H226.174H232.861V451.698H245.857V395.883H175.035V464.775Z",
      "M236.011 454.883L235.996 464.892H239.374V466.285H242.591V463.068H245.853V454.883H236.011Z",
      "M175.032 464.889H232.778V451.703H245.787V395.727H249.023V460.264H245.806V463.248H242.589V460.031H245.787V454.92H235.995V464.889H239.372V468.105H171.814V395.727H175.032V464.889ZM242.59 466.541H239.373V463.324H242.59V466.541ZM249.023 395.725H171.815V392.508H249.023V395.725Z"
    ],
    "x": 210.446
  },
  {
    "y": 422.32899999999995,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M225.035 456.775H276.174H282.861V443.698H295.857V387.883H225.035V456.775Z",
      "M286.011 446.883L285.996 456.892H289.374V458.285H292.591V455.068H295.853V446.883H286.011Z",
      "M225.032 456.889H282.778V443.703H295.787V387.727H299.023V452.264H295.806V455.248H292.589V452.031H295.787V446.92H285.995V456.889H289.372V460.105H221.814V387.727H225.032V456.889ZM292.59 458.541H289.373V455.324H292.59V458.541ZM299.023 387.725H221.815V384.508H299.023V387.725Z"
    ],
    "x": 260.446
  },
  {
    "y": 595.329,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1005.54 629.775H1056.67H1063.36V616.698H1076.36V560.883H1005.54V629.775Z",
      "M1066.51 619.883L1066.5 629.892H1069.87V631.285H1073.09V628.068H1076.35V619.883H1066.51Z",
      "M1005.53 629.889H1063.28V616.703H1076.29V560.727H1079.52V625.264H1076.31V628.248H1073.09V625.031H1076.29V619.92H1066.5V629.889H1069.87V633.105H1002.31V560.727H1005.53V629.889ZM1073.09 631.541H1069.87V628.324H1073.09V631.541ZM1079.52 560.725H1002.32V557.508H1079.52V560.725Z"
    ],
    "x": 1040.9499999999998
  },
  {
    "y": 177.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M928.535 211.775H979.674H986.361V198.698H999.357V142.883H928.535V211.775Z",
      "M989.511 201.883L989.496 211.892H992.874V213.285H996.091V210.068H999.353V201.883H989.511Z",
      "M928.532 211.889H986.278V198.703H999.287V142.727H1002.52V207.264H999.306V210.248H996.089V207.031H999.287V201.92H989.495V211.889H992.872V215.105H925.314V142.727H928.532V211.889ZM996.09 213.541H992.873V210.324H996.09V213.541ZM1002.52 142.725H925.315V139.508H1002.52V142.725Z"
    ],
    "x": 963.9459999999999
  },
  {
    "y": 166.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1330.04 200.775H1381.17H1387.86V187.698H1400.86V131.883H1330.04V200.775Z",
      "M1391.01 190.883L1391 200.892H1394.37V202.285H1397.59V199.068H1400.85V190.883H1391.01Z",
      "M1330.03 200.889H1387.78V187.703H1400.79V131.727H1404.02V196.264H1400.81V199.248H1397.59V196.031H1400.79V190.92H1391V200.889H1394.37V204.105H1326.81V131.727H1330.03V200.889ZM1397.59 202.541H1394.37V199.324H1397.59V202.541ZM1404.02 131.725H1326.82V128.508H1404.02V131.725Z"
    ],
    "x": 1365.4499999999998
  },
  {
    "y": 245.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M730.535 279.775H781.674H788.361V266.698H801.357V210.883H730.535V279.775Z",
      "M791.511 269.883L791.496 279.892H794.874V281.285H798.091V278.068H801.353V269.883H791.511Z",
      "M730.532 279.889H788.278V266.703H801.287V210.727H804.523V275.264H801.306V278.248H798.089V275.031H801.287V269.92H791.495V279.889H794.872V283.105H727.314V210.727H730.532V279.889ZM798.09 281.541H794.873V278.324H798.09V281.541ZM804.523 210.725H727.315V207.508H804.523V210.725Z"
    ],
    "x": 765.9459999999999
  },
  {
    "y": 265.329,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1258.54 299.775H1309.67H1316.36V286.698H1329.36V230.883H1258.54V299.775Z",
      "M1319.51 289.883L1319.5 299.892H1322.87V301.285H1326.09V298.068H1329.35V289.883H1319.51Z",
      "M1258.53 299.889H1316.28V286.703H1329.29V230.727H1332.52V295.264H1329.31V298.248H1326.09V295.031H1329.29V289.92H1319.5V299.889H1322.87V303.105H1255.31V230.727H1258.53V299.889ZM1326.09 301.541H1322.87V298.324H1326.09V301.541ZM1332.52 230.725H1255.32V227.508H1332.52V230.725Z"
    ],
    "x": 1293.9499999999998
  },
  {
    "y": 364.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1066.04 398.775H1117.17H1123.86V385.698H1136.86V329.883H1066.04V398.775Z",
      "M1127.01 388.883L1127 398.892H1130.37V400.285H1133.59V397.068H1136.85V388.883H1127.01Z",
      "M1066.03 398.889H1123.78V385.703H1136.79V329.727H1140.02V394.264H1136.81V397.248H1133.59V394.031H1136.79V388.92H1127V398.889H1130.37V402.105H1062.81V329.727H1066.03V398.889ZM1133.59 400.541H1130.37V397.324H1133.59V400.541ZM1140.02 329.725H1062.82V326.508H1140.02V329.725Z"
    ],
    "x": 1101.4499999999998
  },
  {
    "y": 408.59799999999996,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1139.81 443.044H1190.95H1197.63V429.968H1210.63V374.152H1139.81V443.044Z",
      "M1200.78 433.152L1200.77 443.162H1204.15V444.554H1207.36V441.337H1210.62V433.152H1200.78Z",
      "M1139.8 443.158H1197.55V429.973H1210.56V373.996H1213.79V438.533H1210.58V441.518H1207.36V438.301H1210.56V433.189H1200.77V443.158H1204.14V446.375H1136.59V373.996H1139.8V443.158ZM1207.36 444.811H1204.14V441.594H1207.36V444.811ZM1213.79 373.994H1136.59V370.777H1213.79V373.994Z"
    ],
    "x": 1175.22
  },
  {
    "y": 474.59799999999996,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M417.807 509.044H468.945H475.633V495.968H488.629V440.152H417.807V509.044Z",
      "M478.782 499.152L478.768 509.162H482.145V510.554H485.362V507.337H488.624V499.152H478.782Z",
      "M417.804 509.158H475.55V495.973H488.559V439.996H491.795V504.533H488.577V507.518H485.36V504.301H488.559V499.189H478.767V509.158H482.144V512.375H414.586V439.996H417.804V509.158ZM485.361 510.811H482.145V507.594H485.361V510.811ZM491.795 439.994H414.587V436.777H491.795V439.994Z"
    ],
    "x": 453.218
  },
  {
    "y": 496.32899999999995,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1077.04 530.775H1128.17H1134.86V517.698H1147.86V461.883H1077.04V530.775Z",
      "M1138.01 520.883L1138 530.892H1141.37V532.285H1144.59V529.068H1147.85V520.883H1138.01Z",
      "M1077.03 530.889H1134.78V517.703H1147.79V461.727H1151.02V526.264H1147.81V529.248H1144.59V526.031H1147.79V520.92H1138V530.889H1141.37V534.105H1073.81V461.727H1077.03V530.889ZM1144.59 532.541H1141.37V529.324H1144.59V532.541ZM1151.02 461.725H1073.82V458.508H1151.02V461.725Z"
    ],
    "x": 1112.4499999999998
  },
  {
    "y": 562.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M912.035 596.775H963.174H969.861V583.698H982.857V527.883H912.035V596.775Z",
      "M973.011 586.883L972.996 596.892H976.374V598.285H979.591V595.068H982.853V586.883H973.011Z",
      "M912.032 596.889H969.778V583.703H982.787V527.727H986.023V592.264H982.806V595.248H979.589V592.031H982.787V586.92H972.995V596.889H976.372V600.105H908.814V527.727H912.032V596.889ZM979.59 598.541H976.373V595.324H979.59V598.541ZM986.023 527.725H908.815V524.508H986.023V527.725Z"
    ],
    "x": 947.4459999999999
  },
  {
    "y": 672.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M912.035 706.775H963.174H969.861V693.698H982.857V637.883H912.035V706.775Z",
      "M973.011 696.883L972.996 706.892H976.374V708.285H979.591V705.068H982.853V696.883H973.011Z",
      "M912.032 706.889H969.778V693.703H982.787V637.727H986.023V702.264H982.806V705.248H979.589V702.031H982.787V696.92H972.995V706.889H976.372V710.105H908.814V637.727H912.032V706.889ZM979.59 708.541H976.373V705.324H979.59V708.541ZM986.023 637.725H908.815V634.508H986.023V637.725Z"
    ],
    "x": 947.4459999999999
  },
  {
    "y": 155.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1126.54 189.775H1177.67H1184.36V176.698H1197.36V120.883H1126.54V189.775Z",
      "M1187.51 179.883L1187.5 189.892H1190.87V191.285H1194.09V188.068H1197.35V179.883H1187.51Z",
      "M1126.53 189.889H1184.28V176.703H1197.29V120.727H1200.52V185.264H1197.31V188.248H1194.09V185.031H1197.29V179.92H1187.5V189.889H1190.87V193.105H1123.31V120.727H1126.53V189.889ZM1194.09 191.541H1190.87V188.324H1194.09V191.541ZM1200.52 120.725H1123.32V117.508H1200.52V120.725Z"
    ],
    "x": 1161.9499999999998
  },
  {
    "y": 672.329,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M175.035 706.775H226.174H232.861V693.698H245.857V637.883H175.035V706.775Z",
      "M236.011 696.883L235.996 706.892H239.374V708.285H242.591V705.068H245.853V696.883H236.011Z",
      "M175.032 706.889H232.778V693.703H245.787V637.727H249.023V702.264H245.806V705.248H242.589V702.031H245.787V696.92H235.995V706.889H239.372V710.105H171.814V637.727H175.032V706.889ZM242.59 708.541H239.373V705.324H242.59V708.541ZM249.023 637.725H171.815V634.508H249.023V637.725Z"
    ],
    "x": 210.446
  },
  {
    "y": 397.32899999999995,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1379.54 431.775H1430.67H1437.36V418.698H1450.36V362.883H1379.54V431.775Z",
      "M1440.51 421.883L1440.5 431.892H1443.87V433.285H1447.09V430.068H1450.35V421.883H1440.51Z",
      "M1379.53 431.889H1437.28V418.703H1450.29V362.727H1453.52V427.264H1450.31V430.248H1447.09V427.031H1450.29V421.92H1440.5V431.889H1443.87V435.105H1376.31V362.727H1379.53V431.889ZM1447.09 433.541H1443.87V430.324H1447.09V433.541ZM1453.52 362.725H1376.32V359.508H1453.52V362.725Z"
    ],
    "x": 1414.9499999999998
  },
  {
    "y": 573.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M410.535 607.775H461.674H468.361V594.698H481.357V538.883H410.535V607.775Z",
      "M471.511 597.883L471.496 607.892H474.874V609.285H478.091V606.068H481.353V597.883H471.511Z",
      "M410.532 607.889H468.278V594.703H481.287V538.727H484.523V603.264H481.306V606.248H478.089V603.031H481.287V597.92H471.495V607.889H474.872V611.105H407.314V538.727H410.532V607.889ZM478.09 609.541H474.873V606.324H478.09V609.541ZM484.523 538.725H407.315V535.508H484.523V538.725Z"
    ],
    "x": 445.946
  },
  {
    "y": 672.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1330.04 706.775H1381.17H1387.86V693.698H1400.86V637.883H1330.04V706.775Z",
      "M1391.01 696.883L1391 706.892H1394.37V708.285H1397.59V705.068H1400.85V696.883H1391.01Z",
      "M1330.03 706.889H1387.78V693.703H1400.79V637.727H1404.02V702.264H1400.81V705.248H1397.59V702.031H1400.79V696.92H1391V706.889H1394.37V710.105H1326.81V637.727H1330.03V706.889ZM1397.59 708.541H1394.37V705.324H1397.59V708.541ZM1404.02 637.725H1326.82V634.508H1404.02V637.725Z"
    ],
    "x": 1365.4499999999998
  },
  {
    "y": 290.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1313.54 324.775H1364.67H1371.36V311.698H1384.36V255.883H1313.54V324.775Z",
      "M1374.51 314.883L1374.5 324.892H1377.87V326.285H1381.09V323.068H1384.35V314.883H1374.51Z",
      "M1313.53 324.889H1371.28V311.703H1384.29V255.727H1387.52V320.264H1384.31V323.248H1381.09V320.031H1384.29V314.92H1374.5V324.889H1377.87V328.105H1310.31V255.727H1313.53V324.889ZM1381.09 326.541H1377.87V323.324H1381.09V326.541ZM1387.52 255.725H1310.32V252.508H1387.52V255.725Z"
    ],
    "x": 1348.9499999999998
  },
  {
    "y": 375.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M672.535 409.775H723.674H730.361V396.698H743.357V340.883H672.535V409.775Z",
      "M733.511 399.883L733.496 409.892H736.874V411.285H740.091V408.068H743.353V399.883H733.511Z",
      "M672.532 409.889H730.278V396.703H743.287V340.727H746.523V405.264H743.306V408.248H740.089V405.031H743.287V399.92H733.495V409.889H736.872V413.105H669.314V340.727H672.532V409.889ZM740.09 411.541H736.873V408.324H740.09V411.541ZM746.523 340.725H669.315V337.508H746.523V340.725Z"
    ],
    "x": 707.9459999999999
  },
  {
    "y": 455.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M835.035 489.775H886.174H892.861V476.698H905.857V420.883H835.035V489.775Z",
      "M896.011 479.883L895.996 489.892H899.374V491.285H902.591V488.068H905.853V479.883H896.011Z",
      "M835.032 489.889H892.778V476.703H905.787V420.727H909.023V485.264H905.806V488.248H902.589V485.031H905.787V479.92H895.995V489.889H899.372V493.105H831.814V420.727H835.032V489.889ZM902.59 491.541H899.373V488.324H902.59V491.541ZM909.023 420.725H831.815V417.508H909.023V420.725Z"
    ],
    "x": 870.4459999999999
  },
  {
    "y": 446.59799999999996,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M956.807 481.044H1007.95H1014.63V467.968H1027.63V412.152H956.807V481.044Z",
      "M1017.78 471.152L1017.77 481.162H1021.15V482.554H1024.36V479.337H1027.62V471.152H1017.78Z",
      "M956.804 481.158H1014.55V467.973H1027.56V411.996H1030.79V476.533H1027.58V479.518H1024.36V476.301H1027.56V471.189H1017.77V481.158H1021.14V484.375H953.586V411.996H956.804V481.158ZM1024.36 482.811H1021.14V479.594H1024.36V482.811ZM1030.79 411.994H953.587V408.777H1030.79V411.994Z"
    ],
    "x": 992.2185000000001
  },
  {
    "y": 518.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M329.035 552.775H380.174H386.861V539.698H399.857V483.883H329.035V552.775Z",
      "M390.011 542.883L389.996 552.892H393.374V554.285H396.591V551.068H399.853V542.883H390.011Z",
      "M329.032 552.889H386.778V539.703H399.787V483.727H403.023V548.264H399.806V551.248H396.589V548.031H399.787V542.92H389.995V552.889H393.372V556.105H325.814V483.727H329.032V552.889ZM396.59 554.541H393.373V551.324H396.59V554.541ZM403.023 483.725H325.815V480.508H403.023V483.725Z"
    ],
    "x": 364.446
  },
  {
    "y": 595.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M763.535 629.775H814.674H821.361V616.698H834.357V560.883H763.535V629.775Z",
      "M824.511 619.883L824.496 629.892H827.874V631.285H831.091V628.068H834.353V619.883H824.511Z",
      "M763.532 629.889H821.278V616.703H834.287V560.727H837.523V625.264H834.306V628.248H831.089V625.031H834.287V619.92H824.495V629.889H827.872V633.105H760.314V560.727H763.532V629.889ZM831.09 631.541H827.873V628.324H831.09V631.541ZM837.523 560.725H760.315V557.508H837.523V560.725Z"
    ],
    "x": 798.9459999999999
  },
  {
    "y": 650.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M76.0352 684.775H127.174H133.861V671.698H146.857V615.883H76.0352V684.775Z",
      "M137.011 674.883L136.996 684.892H140.374V686.285H143.591V683.068H146.853V674.883H137.011Z",
      "M76.0322 684.889H133.778V671.703H146.787V615.727H150.023V680.264H146.806V683.248H143.589V680.031H146.787V674.92H136.995V684.889H140.372V688.105H72.8145V615.727H76.0322V684.889ZM143.59 686.541H140.373V683.324H143.59V686.541ZM150.023 615.725H72.8154V612.508H150.023V615.725Z"
    ],
    "x": 111.4461
  },
  {
    "y": 673.329,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M485.535 707.775H536.674H543.361V694.698H556.357V638.883H485.535V707.775Z",
      "M546.511 697.883L546.496 707.892H549.874V709.285H553.091V706.068H556.353V697.883H546.511Z",
      "M485.532 707.889H543.278V694.703H556.287V638.727H559.523V703.264H556.306V706.248H553.089V703.031H556.287V697.92H546.495V707.889H549.872V711.105H482.314V638.727H485.532V707.889ZM553.09 709.541H549.873V706.324H553.09V709.541ZM559.523 638.725H482.315V635.508H559.523V638.725Z"
    ],
    "x": 520.946
  },
  {
    "y": 683.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M697.535 717.775H748.674H755.361V704.698H768.357V648.883H697.535V717.775Z",
      "M758.511 707.883L758.496 717.892H761.874V719.285H765.091V716.068H768.353V707.883H758.511Z",
      "M697.532 717.889H755.278V704.703H768.287V648.727H771.523V713.264H768.306V716.248H765.089V713.031H768.287V707.92H758.495V717.889H761.872V721.105H694.314V648.727H697.532V717.889ZM765.09 719.541H761.873V716.324H765.09V719.541ZM771.523 648.725H694.315V645.508H771.523V648.725Z"
    ],
    "x": 732.9459999999999
  },
  {
    "y": 210.329,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M802.035 244.775H853.174H859.861V231.698H872.857V175.883H802.035V244.775Z",
      "M863.011 234.883L862.996 244.892H866.374V246.285H869.591V243.068H872.853V234.883H863.011Z",
      "M802.032 244.889H859.778V231.703H872.787V175.727H876.023V240.264H872.806V243.248H869.589V240.031H872.787V234.92H862.995V244.889H866.372V248.105H798.814V175.727H802.032V244.889ZM869.59 246.541H866.373V243.324H869.59V246.541ZM876.023 175.725H798.815V172.508H876.023V175.725Z"
    ],
    "x": 837.4459999999999
  },
  {
    "y": 274.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1407.04 308.775H1458.17H1464.86V295.698H1477.86V239.883H1407.04V308.775Z",
      "M1468.01 298.883L1468 308.892H1471.37V310.285H1474.59V307.068H1477.85V298.883H1468.01Z",
      "M1407.03 308.889H1464.78V295.703H1477.79V239.727H1481.02V304.264H1477.81V307.248H1474.59V304.031H1477.79V298.92H1468V308.889H1471.37V312.105H1403.81V239.727H1407.03V308.889ZM1474.59 310.541H1471.37V307.324H1474.59V310.541ZM1481.02 239.725H1403.82V236.508H1481.02V239.725Z"
    ],
    "x": 1442.4499999999998
  },
  {
    "y": 287.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1511.54 321.775H1562.67H1569.36V308.698H1582.36V252.883H1511.54V321.775Z",
      "M1572.51 311.883L1572.5 321.892H1575.87V323.285H1579.09V320.068H1582.35V311.883H1572.51Z",
      "M1511.53 321.889H1569.28V308.703H1582.29V252.727H1585.52V317.264H1582.31V320.248H1579.09V317.031H1582.29V311.92H1572.5V321.889H1575.87V325.105H1508.31V252.727H1511.53V321.889ZM1579.09 323.541H1575.87V320.324H1579.09V323.541ZM1585.52 252.725H1508.32V249.508H1585.52V252.725Z"
    ],
    "x": 1546.9499999999998
  },
  {
    "y": 442.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M647.035 476.775H698.174H704.861V463.698H717.857V407.883H647.035V476.775Z",
      "M708.011 466.883L707.996 476.892H711.374V478.285H714.591V475.068H717.853V466.883H708.011Z",
      "M647.032 476.889H704.778V463.703H717.787V407.727H721.023V472.264H717.806V475.248H714.589V472.031H717.787V466.92H707.995V476.889H711.372V480.105H643.814V407.727H647.032V476.889ZM714.59 478.541H711.373V475.324H714.59V478.541ZM721.023 407.725H643.815V404.508H721.023V407.725Z"
    ],
    "x": 682.4459999999999
  },
  {
    "y": 452.32899999999995,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1256.04 486.775H1307.17H1313.86V473.698H1326.86V417.883H1256.04V486.775Z",
      "M1317.01 476.883L1317 486.892H1320.37V488.285H1323.59V485.068H1326.85V476.883H1317.01Z",
      "M1256.03 486.889H1313.78V473.703H1326.79V417.727H1330.02V482.264H1326.81V485.248H1323.59V482.031H1326.79V476.92H1317V486.889H1320.37V490.105H1252.81V417.727H1256.03V486.889ZM1323.59 488.541H1320.37V485.324H1323.59V488.541ZM1330.02 417.725H1252.82V414.508H1330.02V417.725Z"
    ],
    "x": 1291.4499999999998
  },
  {
    "y": 485.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M719.535 519.775H770.674H777.361V506.698H790.357V450.883H719.535V519.775Z",
      "M780.511 509.883L780.496 519.892H783.874V521.285H787.091V518.068H790.353V509.883H780.511Z",
      "M719.532 519.889H777.278V506.703H790.287V450.727H793.523V515.264H790.306V518.248H787.089V515.031H790.287V509.92H780.495V519.889H783.872V523.105H716.314V450.727H719.532V519.889ZM787.09 521.541H783.873V518.324H787.09V521.541ZM793.523 450.725H716.315V447.508H793.523V450.725Z"
    ],
    "x": 754.9459999999999
  },
  {
    "y": 528.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M794.535 562.775H845.674H852.361V549.698H865.357V493.883H794.535V562.775Z",
      "M855.511 552.883L855.496 562.892H858.874V564.285H862.091V561.068H865.353V552.883H855.511Z",
      "M794.532 562.889H852.278V549.703H865.287V493.727H868.523V558.264H865.306V561.248H862.089V558.031H865.287V552.92H855.495V562.889H858.872V566.105H791.314V493.727H794.532V562.889ZM862.09 564.541H858.873V561.324H862.09V564.541ZM868.523 493.725H791.315V490.508H868.523V493.725Z"
    ],
    "x": 829.9459999999999
  },
  {
    "y": 546.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M560.035 580.775H611.174H617.861V567.698H630.857V511.883H560.035V580.775Z",
      "M621.011 570.883L620.996 580.892H624.374V582.285H627.591V579.068H630.853V570.883H621.011Z",
      "M560.032 580.889H617.778V567.703H630.787V511.727H634.023V576.264H630.806V579.248H627.589V576.031H630.787V570.92H620.995V580.889H624.372V584.105H556.814V511.727H560.032V580.889ZM627.59 582.541H624.373V579.324H627.59V582.541ZM634.023 511.725H556.815V508.508H634.023V511.725Z"
    ],
    "x": 595.4459999999999
  },
  {
    "y": 540.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1693.04 574.775H1744.17H1750.86V561.698H1763.86V505.883H1693.04V574.775Z",
      "M1754.01 564.883L1754 574.892H1757.37V576.285H1760.59V573.068H1763.85V564.883H1754.01Z",
      "M1693.03 574.889H1750.78V561.703H1763.79V505.727H1767.02V570.264H1763.81V573.248H1760.59V570.031H1763.79V564.92H1754V574.889H1757.37V578.105H1689.81V505.727H1693.03V574.889ZM1760.59 576.541H1757.37V573.324H1760.59V576.541ZM1767.02 505.725H1689.82V502.508H1767.02V505.725Z"
    ],
    "x": 1728.4499999999998
  },
  {
    "y": 551.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1192.54 585.775H1243.67H1250.36V572.698H1263.36V516.883H1192.54V585.775Z",
      "M1253.51 575.883L1253.5 585.892H1256.87V587.285H1260.09V584.068H1263.35V575.883H1253.51Z",
      "M1192.53 585.889H1250.28V572.703H1263.29V516.727H1266.52V581.264H1263.31V584.248H1260.09V581.031H1263.29V575.92H1253.5V585.889H1256.87V589.105H1189.31V516.727H1192.53V585.889ZM1260.09 587.541H1256.87V584.324H1260.09V587.541ZM1266.52 516.725H1189.32V513.508H1266.52V516.725Z"
    ],
    "x": 1227.9499999999998
  },
  {
    "y": 617.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M191.535 651.775H242.674H249.361V638.698H262.357V582.883H191.535V651.775Z",
      "M252.511 641.883L252.496 651.892H255.874V653.285H259.091V650.068H262.353V641.883H252.511Z",
      "M191.532 651.889H249.278V638.703H262.287V582.727H265.523V647.264H262.306V650.248H259.089V647.031H262.287V641.92H252.495V651.889H255.872V655.105H188.314V582.727H191.532V651.889ZM259.09 653.541H255.873V650.324H259.09V653.541ZM265.523 582.725H188.315V579.508H265.523V582.725Z"
    ],
    "x": 226.94600000000003
  },
  {
    "y": 585.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M254.535 619.775H305.674H312.361V606.698H325.357V550.883H254.535V619.775Z",
      "M315.511 609.883L315.496 619.892H318.874V621.285H322.091V618.068H325.353V609.883H315.511Z",
      "M254.532 619.889H312.278V606.703H325.287V550.727H328.523V615.264H325.306V618.248H322.089V615.031H325.287V609.92H315.495V619.889H318.872V623.105H251.314V550.727H254.532V619.889ZM322.09 621.541H318.873V618.324H322.09V621.541ZM328.523 550.725H251.315V547.508H328.523V550.725Z"
    ],
    "x": 289.946
  },
  {
    "y": 582.598,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M64.8066 617.044H115.945H122.633V603.968H135.629V548.152H64.8066V617.044Z",
      "M125.782 607.152L125.768 617.162H129.145V618.554H132.362V615.337H135.624V607.152H125.782Z",
      "M64.8037 617.158H122.55V603.973H135.559V547.996H138.795V612.533H135.577V615.518H132.36V612.301H135.559V607.189H125.767V617.158H129.144V620.375H61.5859V547.996H64.8037V617.158ZM132.361 618.811H129.145V615.594H132.361V618.811ZM138.795 547.994H61.5869V544.777H138.795V547.994Z"
    ],
    "x": 100.2178
  },
  {
    "y": 683.329,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M587.535 717.775H638.674H645.361V704.698H658.357V648.883H587.535V717.775Z",
      "M648.511 707.883L648.496 717.892H651.874V719.285H655.091V716.068H658.353V707.883H648.511Z",
      "M587.532 717.889H645.278V704.703H658.287V648.727H661.523V713.264H658.306V716.248H655.089V713.031H658.287V707.92H648.495V717.889H651.872V721.105H584.314V648.727H587.532V717.889ZM655.09 719.541H651.873V716.324H655.09V719.541ZM661.523 648.725H584.315V645.508H661.523V648.725Z"
    ],
    "x": 622.9459999999999
  },
  {
    "y": 430.32899999999995,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M560.035 464.775H611.174H617.861V451.698H630.857V395.883H560.035V464.775Z",
      "M621.011 454.883L620.996 464.892H624.374V466.285H627.591V463.068H630.853V454.883H621.011Z",
      "M560.032 464.889H617.778V451.703H630.787V395.727H634.023V460.264H630.806V463.248H627.589V460.031H630.787V454.92H620.995V464.889H624.372V468.105H556.814V395.727H560.032V464.889ZM627.59 466.541H624.373V463.324H627.59V466.541ZM634.023 395.725H556.815V392.508H634.023V395.725Z"
    ],
    "x": 595.4459999999999
  },
  {
    "y": 496.32899999999995,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M197.035 530.775H248.174H254.861V517.698H267.857V461.883H197.035V530.775Z",
      "M258.011 520.883L257.996 530.892H261.374V532.285H264.591V529.068H267.853V520.883H258.011Z",
      "M197.032 530.889H254.778V517.703H267.787V461.727H271.023V526.264H267.806V529.248H264.589V526.031H267.787V520.92H257.995V530.889H261.372V534.105H193.814V461.727H197.032V530.889ZM264.59 532.541H261.373V529.324H264.59V532.541ZM271.023 461.725H193.815V458.508H271.023V461.725Z"
    ],
    "x": 232.44600000000003
  },
  {
    "y": 516.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1626.04 550.775H1677.17H1683.86V537.698H1696.86V481.883H1626.04V550.775Z",
      "M1687.01 540.883L1687 550.892H1690.37V552.285H1693.59V549.068H1696.85V540.883H1687.01Z",
      "M1626.03 550.889H1683.78V537.703H1696.79V481.727H1700.02V546.264H1696.81V549.248H1693.59V546.031H1696.79V540.92H1687V550.889H1690.37V554.105H1622.81V481.727H1626.03V550.889ZM1693.59 552.541H1690.37V549.324H1693.59V552.541ZM1700.02 481.725H1622.82V478.508H1700.02V481.725Z"
    ],
    "x": 1661.4499999999998
  },
  {
    "y": 540.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1462.04 574.775H1513.17H1519.86V561.698H1532.86V505.883H1462.04V574.775Z",
      "M1523.01 564.883L1523 574.892H1526.37V576.285H1529.59V573.068H1532.85V564.883H1523.01Z",
      "M1462.03 574.889H1519.78V561.703H1532.79V505.727H1536.02V570.264H1532.81V573.248H1529.59V570.031H1532.79V564.92H1523V574.889H1526.37V578.105H1458.81V505.727H1462.03V574.889ZM1529.59 576.541H1526.37V573.324H1529.59V576.541ZM1536.02 505.725H1458.82V502.508H1536.02V505.725Z"
    ],
    "x": 1497.4499999999998
  },
  {
    "y": 573.329,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M455.535 607.775H506.674H513.361V594.698H526.357V538.883H455.535V607.775Z",
      "M516.511 597.883L516.496 607.892H519.874V609.285H523.091V606.068H526.353V597.883H516.511Z",
      "M455.532 607.889H513.278V594.703H526.287V538.727H529.523V603.264H526.306V606.248H523.089V603.031H526.287V597.92H516.495V607.889H519.872V611.105H452.314V538.727H455.532V607.889ZM523.09 609.541H519.873V606.324H523.09V609.541ZM529.523 538.725H452.315V535.508H529.523V538.725Z"
    ],
    "x": 490.946
  },
  {
    "y": 617.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1313.54 651.775H1364.67H1371.36V638.698H1384.36V582.883H1313.54V651.775Z",
      "M1374.51 641.883L1374.5 651.892H1377.87V653.285H1381.09V650.068H1384.35V641.883H1374.51Z",
      "M1313.53 651.889H1371.28V638.703H1384.29V582.727H1387.52V647.264H1384.31V650.248H1381.09V647.031H1384.29V641.92H1374.5V651.889H1377.87V655.105H1310.31V582.727H1313.53V651.889ZM1381.09 653.541H1377.87V650.324H1381.09V653.541ZM1387.52 582.725H1310.32V579.508H1387.52V582.725Z"
    ],
    "x": 1348.9499999999998
  },
  {
    "y": 243.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M917.535 277.775H968.674H975.361V264.698H988.357V208.883H917.535V277.775Z",
      "M978.511 267.883L978.496 277.892H981.874V279.285H985.091V276.068H988.353V267.883H978.511Z",
      "M917.532 277.889H975.278V264.703H988.287V208.727H991.523V273.264H988.306V276.248H985.089V273.031H988.287V267.92H978.495V277.889H981.872V281.105H914.314V208.727H917.532V277.889ZM985.09 279.541H981.873V276.324H985.09V279.541ZM991.523 208.725H914.315V205.508H991.523V208.725Z"
    ],
    "x": 952.9459999999999
  },
  {
    "y": 276.329,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M989.035 310.775H1040.17H1046.86V297.698H1059.86V241.883H989.035V310.775Z",
      "M1050.01 300.883L1050 310.892H1053.37V312.285H1056.59V309.068H1059.85V300.883H1050.01Z",
      "M989.032 310.889H1046.78V297.703H1059.79V241.727H1063.02V306.264H1059.81V309.248H1056.59V306.031H1059.79V300.92H1050V310.889H1053.37V314.105H985.814V241.727H989.032V310.889ZM1056.59 312.541H1053.37V309.324H1056.59V312.541ZM1063.02 241.725H985.815V238.508H1063.02V241.725Z"
    ],
    "x": 1024.4475
  },
  {
    "y": 386.32899999999995,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1591.04 420.775H1642.17H1648.86V407.698H1661.86V351.883H1591.04V420.775Z",
      "M1652.01 410.883L1652 420.892H1655.37V422.285H1658.59V419.068H1661.85V410.883H1652.01Z",
      "M1591.03 420.889H1648.78V407.703H1661.79V351.727H1665.02V416.264H1661.81V419.248H1658.59V416.031H1661.79V410.92H1652V420.889H1655.37V424.105H1587.81V351.727H1591.03V420.889ZM1658.59 422.541H1655.37V419.324H1658.59V422.541ZM1665.02 351.725H1587.82V348.508H1665.02V351.725Z"
    ],
    "x": 1626.4499999999998
  },
  {
    "y": 386.32899999999995,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1551.04 420.775H1602.17H1608.86V407.698H1621.86V351.883H1551.04V420.775Z",
      "M1612.01 410.883L1612 420.892H1615.37V422.285H1618.59V419.068H1621.85V410.883H1612.01Z",
      "M1551.03 420.889H1608.78V407.703H1621.79V351.727H1625.02V416.264H1621.81V419.248H1618.59V416.031H1621.79V410.92H1612V420.889H1615.37V424.105H1547.81V351.727H1551.03V420.889ZM1618.59 422.541H1615.37V419.324H1618.59V422.541ZM1625.02 351.725H1547.82V348.508H1625.02V351.725Z"
    ],
    "x": 1586.4499999999998
  },
  {
    "y": 606.329,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M879.035 640.775H930.174H936.861V627.698H949.857V571.883H879.035V640.775Z",
      "M940.011 630.883L939.996 640.892H943.374V642.285H946.591V639.068H949.853V630.883H940.011Z",
      "M879.032 640.889H936.778V627.703H949.787V571.727H953.023V636.264H949.806V639.248H946.589V636.031H949.787V630.92H939.995V640.889H943.372V644.105H875.814V571.727H879.032V640.889ZM946.59 642.541H943.373V639.324H946.59V642.541ZM953.023 571.725H875.815V568.508H953.023V571.725Z"
    ],
    "x": 914.4459999999999
  },
  {
    "y": 640.329,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1649.04 674.775H1700.17H1706.86V661.698H1719.86V605.883H1649.04V674.775Z",
      "M1710.01 664.883L1710 674.892H1713.37V676.285H1716.59V673.068H1719.85V664.883H1710.01Z",
      "M1649.03 674.889H1706.78V661.703H1719.79V605.727H1723.02V670.264H1719.81V673.248H1716.59V670.031H1719.79V664.92H1710V674.889H1713.37V678.105H1645.81V605.727H1649.03V674.889ZM1716.59 676.541H1713.37V673.324H1716.59V676.541ZM1723.02 605.725H1645.82V602.508H1723.02V605.725Z"
    ],
    "x": 1684.4499999999998
  },
  {
    "y": 277.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1632.54 311.775H1683.67H1690.36V298.698H1703.36V242.883H1632.54V311.775Z",
      "M1693.51 301.883L1693.5 311.892H1696.87V313.285H1700.09V310.068H1703.35V301.883H1693.51Z",
      "M1632.53 311.889H1690.28V298.703H1703.29V242.727H1706.52V307.264H1703.31V310.248H1700.09V307.031H1703.29V301.92H1693.5V311.889H1696.87V315.105H1629.31V242.727H1632.53V311.889ZM1700.09 313.541H1696.87V310.324H1700.09V313.541ZM1706.52 242.725H1629.32V239.508H1706.52V242.725Z"
    ],
    "x": 1667.9499999999998
  },
  {
    "y": 144.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1405.04 178.775H1456.17H1462.86V165.698H1475.86V109.883H1405.04V178.775Z",
      "M1466.01 168.883L1466 178.892H1469.37V180.285H1472.59V177.068H1475.85V168.883H1466.01Z",
      "M1405.03 178.889H1462.78V165.703H1475.79V109.727H1479.02V174.264H1475.81V177.248H1472.59V174.031H1475.79V168.92H1466V178.889H1469.37V182.105H1401.81V109.727H1405.03V178.889ZM1472.59 180.541H1469.37V177.324H1472.59V180.541ZM1479.02 109.725H1401.82V106.508H1479.02V109.725Z"
    ],
    "x": 1440.4499999999998
  },
  {
    "y": 166.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M978.035 200.775H1029.17H1035.86V187.698H1048.86V131.883H978.035V200.775Z",
      "M1039.01 190.883L1039 200.892H1042.37V202.285H1045.59V199.068H1048.85V190.883H1039.01Z",
      "M978.032 200.889H1035.78V187.703H1048.79V131.727H1052.02V196.264H1048.81V199.248H1045.59V196.031H1048.79V190.92H1039V200.889H1042.37V204.105H974.814V131.727H978.032V200.889ZM1045.59 202.541H1042.37V199.324H1045.59V202.541ZM1052.02 131.725H974.815V128.508H1052.02V131.725Z"
    ],
    "x": 1013.4475
  },
  {
    "y": 199.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1511.54 233.775H1562.67H1569.36V220.698H1582.36V164.883H1511.54V233.775Z",
      "M1572.51 223.883L1572.5 233.892H1575.87V235.285H1579.09V232.068H1582.35V223.883H1572.51Z",
      "M1511.53 233.889H1569.28V220.703H1582.29V164.727H1585.52V229.264H1582.31V232.248H1579.09V229.031H1582.29V223.92H1572.5V233.889H1575.87V237.105H1508.31V164.727H1511.53V233.889ZM1579.09 235.541H1575.87V232.324H1579.09V235.541ZM1585.52 164.725H1508.32V161.508H1585.52V164.725Z"
    ],
    "x": 1546.9499999999998
  },
  {
    "y": 259.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1541.54 293.775H1592.67H1599.36V280.698H1612.36V224.883H1541.54V293.775Z",
      "M1602.51 283.883L1602.5 293.892H1605.87V295.285H1609.09V292.068H1612.35V283.883H1602.51Z",
      "M1541.53 293.889H1599.28V280.703H1612.29V224.727H1615.52V289.264H1612.31V292.248H1609.09V289.031H1612.29V283.92H1602.5V293.889H1605.87V297.105H1538.31V224.727H1541.53V293.889ZM1609.09 295.541H1605.87V292.324H1609.09V295.541ZM1615.52 224.725H1538.32V221.508H1615.52V224.725Z"
    ],
    "x": 1576.9499999999998
  },
  {
    "y": 218.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1154.04 252.775H1205.17H1211.86V239.698H1224.86V183.883H1154.04V252.775Z",
      "M1215.01 242.883L1215 252.892H1218.37V254.285H1221.59V251.068H1224.85V242.883H1215.01Z",
      "M1154.03 252.889H1211.78V239.703H1224.79V183.727H1228.02V248.264H1224.81V251.248H1221.59V248.031H1224.79V242.92H1215V252.889H1218.37V256.105H1150.81V183.727H1154.03V252.889ZM1221.59 254.541H1218.37V251.324H1221.59V254.541ZM1228.02 183.725H1150.82V180.508H1228.02V183.725Z"
    ],
    "x": 1189.4499999999998
  },
  {
    "y": 210.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1241.04 244.775H1292.17H1298.86V231.698H1311.86V175.883H1241.04V244.775Z",
      "M1302.01 234.883L1302 244.892H1305.37V246.285H1308.59V243.068H1311.85V234.883H1302.01Z",
      "M1241.03 244.889H1298.78V231.703H1311.79V175.727H1315.02V240.264H1311.81V243.248H1308.59V240.031H1311.79V234.92H1302V244.889H1305.37V248.105H1237.81V175.727H1241.03V244.889ZM1308.59 246.541H1305.37V243.324H1308.59V246.541ZM1315.02 175.725H1237.82V172.508H1315.02V175.725Z"
    ],
    "x": 1276.4499999999998
  },
  {
    "y": 232.329,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1352.04 266.775H1403.17H1409.86V253.698H1422.86V197.883H1352.04V266.775Z",
      "M1413.01 256.883L1413 266.892H1416.37V268.285H1419.59V265.068H1422.85V256.883H1413.01Z",
      "M1352.03 266.889H1409.78V253.703H1422.79V197.727H1426.02V262.264H1422.81V265.248H1419.59V262.031H1422.79V256.92H1413V266.889H1416.37V270.105H1348.81V197.727H1352.03V266.889ZM1419.59 268.541H1416.37V265.324H1419.59V268.541ZM1426.02 197.725H1348.82V194.508H1426.02V197.725Z"
    ],
    "x": 1387.4499999999998
  },
  {
    "y": 287.329,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1159.54 321.775H1210.67H1217.36V308.698H1230.36V252.883H1159.54V321.775Z",
      "M1220.51 311.883L1220.5 321.892H1223.87V323.285H1227.09V320.068H1230.35V311.883H1220.51Z",
      "M1159.53 321.889H1217.28V308.703H1230.29V252.727H1233.52V317.264H1230.31V320.248H1227.09V317.031H1230.29V311.92H1220.5V321.889H1223.87V325.105H1156.31V252.727H1159.53V321.889ZM1227.09 323.541H1223.87V320.324H1227.09V323.541ZM1233.52 252.725H1156.32V249.508H1233.52V252.725Z"
    ],
    "x": 1194.9499999999998
  },
  {
    "y": 208.329,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1185.54 242.775H1236.67H1243.36V229.698H1256.36V173.883H1185.54V242.775Z",
      "M1246.51 232.883L1246.5 242.892H1249.87V244.285H1253.09V241.068H1256.35V232.883H1246.51Z",
      "M1185.53 242.889H1243.28V229.703H1256.29V173.727H1259.52V238.264H1256.31V241.248H1253.09V238.031H1256.29V232.92H1246.5V242.889H1249.87V246.105H1182.31V173.727H1185.53V242.889ZM1253.09 244.541H1249.87V241.324H1253.09V244.541ZM1259.52 173.725H1182.32V170.508H1259.52V173.725Z"
    ],
    "x": 1220.9499999999998
  },
  {
    "y": 309.32899999999995,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M819.535 343.775H870.674H877.361V330.698H890.357V274.883H819.535V343.775Z",
      "M880.511 333.883L880.496 343.892H883.874V345.285H887.091V342.068H890.353V333.883H880.511Z",
      "M819.532 343.889H877.278V330.703H890.287V274.727H893.523V339.264H890.306V342.248H887.089V339.031H890.287V333.92H880.495V343.889H883.872V347.105H816.314V274.727H819.532V343.889ZM887.09 345.541H883.873V342.324H887.09V345.541ZM893.523 274.725H816.315V271.508H893.523V274.725Z"
    ],
    "x": 854.9459999999999
  },
  {
    "y": 331.32899999999995,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1665.54 365.775H1716.67H1723.36V352.698H1736.36V296.883H1665.54V365.775Z",
      "M1726.51 355.883L1726.5 365.892H1729.87V367.285H1733.09V364.068H1736.35V355.883H1726.51Z",
      "M1665.53 365.889H1723.28V352.703H1736.29V296.727H1739.52V361.264H1736.31V364.248H1733.09V361.031H1736.29V355.92H1726.5V365.889H1729.87V369.105H1662.31V296.727H1665.53V365.889ZM1733.09 367.541H1729.87V364.324H1733.09V367.541ZM1739.52 296.725H1662.32V293.508H1739.52V296.725Z"
    ],
    "x": 1700.9499999999998
  },
  {
    "y": 342.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1397.04 376.775H1448.17H1454.86V363.698H1467.86V307.883H1397.04V376.775Z",
      "M1458.01 366.883L1458 376.892H1461.37V378.285H1464.59V375.068H1467.85V366.883H1458.01Z",
      "M1397.03 376.889H1454.78V363.703H1467.79V307.727H1471.02V372.264H1467.81V375.248H1464.59V372.031H1467.79V366.92H1458V376.889H1461.37V380.105H1393.81V307.727H1397.03V376.889ZM1464.59 378.541H1461.37V375.324H1464.59V378.541ZM1471.02 307.725H1393.82V304.508H1471.02V307.725Z"
    ],
    "x": 1432.4499999999998
  },
  {
    "y": 353.32899999999995,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1470.54 387.775H1521.67H1528.36V374.698H1541.36V318.883H1470.54V387.775Z",
      "M1531.51 377.883L1531.5 387.892H1534.87V389.285H1538.09V386.068H1541.35V377.883H1531.51Z",
      "M1470.53 387.889H1528.28V374.703H1541.29V318.727H1544.52V383.264H1541.31V386.248H1538.09V383.031H1541.29V377.92H1531.5V387.889H1534.87V391.105H1467.31V318.727H1470.53V387.889ZM1538.09 389.541H1534.87V386.324H1538.09V389.541ZM1544.52 318.725H1467.32V315.508H1544.52V318.725Z"
    ],
    "x": 1505.9499999999998
  },
  {
    "y": 364.32899999999995,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1231.04 398.775H1282.17H1288.86V385.698H1301.86V329.883H1231.04V398.775Z",
      "M1292.01 388.883L1292 398.892H1295.37V400.285H1298.59V397.068H1301.85V388.883H1292.01Z",
      "M1231.03 398.889H1288.78V385.703H1301.79V329.727H1305.02V394.264H1301.81V397.248H1298.59V394.031H1301.79V388.92H1292V398.889H1295.37V402.105H1227.81V329.727H1231.03V398.889ZM1298.59 400.541H1295.37V397.324H1298.59V400.541ZM1305.02 329.725H1227.82V326.508H1305.02V329.725Z"
    ],
    "x": 1266.4499999999998
  },
  {
    "y": 386.32899999999995,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M481.035 420.775H532.174H538.861V407.698H551.857V351.883H481.035V420.775Z",
      "M542.011 410.883L541.996 420.892H545.374V422.285H548.591V419.068H551.853V410.883H542.011Z",
      "M481.032 420.889H538.778V407.703H551.787V351.727H555.023V416.264H551.806V419.248H548.589V416.031H551.787V410.92H541.995V420.889H545.372V424.105H477.814V351.727H481.032V420.889ZM548.59 422.541H545.373V419.324H548.59V422.541ZM555.023 351.725H477.815V348.508H555.023V351.725Z"
    ],
    "x": 516.446
  },
  {
    "y": 437.59799999999996,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M108.807 472.044H159.945H166.633V458.968H179.629V403.152H108.807V472.044Z",
      "M169.782 462.152L169.768 472.162H173.145V473.554H176.362V470.337H179.624V462.152H169.782Z",
      "M108.804 472.158H166.55V458.973H179.559V402.996H182.795V467.533H179.577V470.518H176.36V467.301H179.559V462.189H169.767V472.158H173.144V475.375H105.586V402.996H108.804V472.158ZM176.361 473.811H173.145V470.594H176.361V473.811ZM182.795 402.994H105.587V399.777H182.795V402.994Z"
    ],
    "x": 144.218
  },
  {
    "y": 441.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1434.54 475.775H1485.67H1492.36V462.698H1505.36V406.883H1434.54V475.775Z",
      "M1495.51 465.883L1495.5 475.892H1498.87V477.285H1502.09V474.068H1505.35V465.883H1495.51Z",
      "M1434.53 475.889H1492.28V462.703H1505.29V406.727H1508.52V471.264H1505.31V474.248H1502.09V471.031H1505.29V465.92H1495.5V475.889H1498.87V479.105H1431.31V406.727H1434.53V475.889ZM1502.09 477.541H1498.87V474.324H1502.09V477.541ZM1508.52 406.725H1431.32V403.508H1508.52V406.725Z"
    ],
    "x": 1469.9499999999998
  },
  {
    "y": 463.32899999999995,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1115.54 497.775H1166.67H1173.36V484.698H1186.36V428.883H1115.54V497.775Z",
      "M1176.51 487.883L1176.5 497.892H1179.87V499.285H1183.09V496.068H1186.35V487.883H1176.51Z",
      "M1115.53 497.889H1173.28V484.703H1186.29V428.727H1189.52V493.264H1186.31V496.248H1183.09V493.031H1186.29V487.92H1176.5V497.889H1179.87V501.105H1112.31V428.727H1115.53V497.889ZM1183.09 499.541H1179.87V496.324H1183.09V499.541ZM1189.52 428.725H1112.32V425.508H1189.52V428.725Z"
    ],
    "x": 1150.9499999999998
  },
  {
    "y": 474.59799999999996,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M512.807 509.044H563.945H570.633V495.968H583.629V440.152H512.807V509.044Z",
      "M573.782 499.152L573.768 509.162H577.145V510.554H580.362V507.337H583.624V499.152H573.782Z",
      "M512.804 509.158H570.55V495.973H583.559V439.996H586.795V504.533H583.577V507.518H580.36V504.301H583.559V499.189H573.767V509.158H577.144V512.375H509.586V439.996H512.804V509.158ZM580.361 510.811H577.145V507.594H580.361V510.811ZM586.795 439.994H509.587V436.777H586.795V439.994Z"
    ],
    "x": 548.2180000000001
  },
  {
    "y": 474.32899999999995,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1187.04 508.775H1238.17H1244.86V495.698H1257.86V439.883H1187.04V508.775Z",
      "M1248.01 498.883L1248 508.892H1251.37V510.285H1254.59V507.068H1257.85V498.883H1248.01Z",
      "M1187.03 508.889H1244.78V495.703H1257.79V439.727H1261.02V504.264H1257.81V507.248H1254.59V504.031H1257.79V498.92H1248V508.889H1251.37V512.105H1183.81V439.727H1187.03V508.889ZM1254.59 510.541H1251.37V507.324H1254.59V510.541ZM1261.02 439.725H1183.82V436.508H1261.02V439.725Z"
    ],
    "x": 1222.4499999999998
  },
  {
    "y": 538.329,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M615.035 572.775H666.174H672.861V559.698H685.857V503.883H615.035V572.775Z",
      "M676.011 562.883L675.996 572.892H679.374V574.285H682.591V571.068H685.853V562.883H676.011Z",
      "M615.032 572.889H672.778V559.703H685.787V503.727H689.023V568.264H685.806V571.248H682.589V568.031H685.787V562.92H675.995V572.889H679.372V576.105H611.814V503.727H615.032V572.889ZM682.59 574.541H679.373V571.324H682.59V574.541ZM689.023 503.725H611.815V500.508H689.023V503.725Z"
    ],
    "x": 650.4459999999999
  },
  {
    "y": 578.329,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M615.035 612.775H666.174H672.861V599.698H685.857V543.883H615.035V612.775Z",
      "M676.011 602.883L675.996 612.892H679.374V614.285H682.591V611.068H685.853V602.883H676.011Z",
      "M615.032 612.889H672.778V599.703H685.787V543.727H689.023V608.264H685.806V611.248H682.589V608.031H685.787V602.92H675.995V612.889H679.372V616.105H611.814V543.727H615.032V612.889ZM682.59 614.541H679.373V611.324H682.59V614.541ZM689.023 543.725H611.815V540.508H689.023V543.725Z"
    ],
    "x": 650.4459999999999
  },
  {
    "y": 540.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1110.04 574.775H1161.17H1167.86V561.698H1180.86V505.883H1110.04V574.775Z",
      "M1171.01 564.883L1171 574.892H1174.37V576.285H1177.59V573.068H1180.85V564.883H1171.01Z",
      "M1110.03 574.889H1167.78V561.703H1180.79V505.727H1184.02V570.264H1180.81V573.248H1177.59V570.031H1180.79V564.92H1171V574.889H1174.37V578.105H1106.81V505.727H1110.03V574.889ZM1177.59 576.541H1174.37V573.324H1177.59V576.541ZM1184.02 505.725H1106.82V502.508H1184.02V505.725Z"
    ],
    "x": 1145.4499999999998
  },
  {
    "y": 584.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1383.04 618.775H1434.17H1440.86V605.698H1453.86V549.883H1383.04V618.775Z",
      "M1444.01 608.883L1444 618.892H1447.37V620.285H1450.59V617.068H1453.85V608.883H1444.01Z",
      "M1383.03 618.889H1440.78V605.703H1453.79V549.727H1457.02V614.264H1453.81V617.248H1450.59V614.031H1453.79V608.92H1444V618.889H1447.37V622.105H1379.81V549.727H1383.03V618.889ZM1450.59 620.541H1447.37V617.324H1450.59V620.541ZM1457.02 549.725H1379.82V546.508H1457.02V549.725Z"
    ],
    "x": 1418.4499999999998
  },
  {
    "y": 580.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1582.04 614.775H1633.17H1639.86V601.698H1652.86V545.883H1582.04V614.775Z",
      "M1643.01 604.883L1643 614.892H1646.37V616.285H1649.59V613.068H1652.85V604.883H1643.01Z",
      "M1582.03 614.889H1639.78V601.703H1652.79V545.727H1656.02V610.264H1652.81V613.248H1649.59V610.031H1652.79V604.92H1643V614.889H1646.37V618.105H1578.81V545.727H1582.03V614.889ZM1649.59 616.541H1646.37V613.324H1649.59V616.541ZM1656.02 545.725H1578.82V542.508H1656.02V545.725Z"
    ],
    "x": 1617.4499999999998
  },
  {
    "y": 474.32899999999995,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M296.035 508.775H347.174H353.861V495.698H366.857V439.883H296.035V508.775Z",
      "M357.011 498.883L356.996 508.892H360.374V510.285H363.591V507.068H366.853V498.883H357.011Z",
      "M296.032 508.889H353.778V495.703H366.787V439.727H370.023V504.264H366.806V507.248H363.589V504.031H366.787V498.92H356.995V508.889H360.372V512.105H292.814V439.727H296.032V508.889ZM363.59 510.541H360.373V507.324H363.59V510.541ZM370.023 439.725H292.815V436.508H370.023V439.725Z"
    ],
    "x": 331.446
  },
  {
    "y": 408.32899999999995,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M272.035 442.775H323.174H329.861V429.698H342.857V373.883H272.035V442.775Z",
      "M333.011 432.883L332.996 442.892H336.374V444.285H339.591V441.068H342.853V432.883H333.011Z",
      "M272.032 442.889H329.778V429.703H342.787V373.727H346.023V438.264H342.806V441.248H339.589V438.031H342.787V432.92H332.995V442.889H336.372V446.105H268.814V373.727H272.032V442.889ZM339.59 444.541H336.373V441.324H339.59V444.541ZM346.023 373.725H268.815V370.508H346.023V373.725Z"
    ],
    "x": 307.446
  },
  {
    "y": 694.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M813.035 728.775H864.174H870.861V715.698H883.857V659.883H813.035V728.775Z",
      "M874.011 718.883L873.996 728.892H877.374V730.285H880.591V727.068H883.853V718.883H874.011Z",
      "M813.032 728.889H870.778V715.703H883.787V659.727H887.023V724.264H883.806V727.248H880.589V724.031H883.787V718.92H873.995V728.889H877.372V732.105H809.814V659.727H813.032V728.889ZM880.59 730.541H877.373V727.324H880.59V730.541ZM887.023 659.725H809.815V656.508H887.023V659.725Z"
    ],
    "x": 848.4459999999999
  },
  {
    "y": 683.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M125.535 717.775H176.674H183.361V704.698H196.357V648.883H125.535V717.775Z",
      "M186.511 707.883L186.496 717.892H189.874V719.285H193.091V716.068H196.353V707.883H186.511Z",
      "M125.532 717.889H183.278V704.703H196.287V648.727H199.523V713.264H196.306V716.248H193.089V713.031H196.287V707.92H186.495V717.889H189.872V721.105H122.314V648.727H125.532V717.889ZM193.09 719.541H189.873V716.324H193.09V719.541ZM199.523 648.725H122.315V645.508H199.523V648.725Z"
    ],
    "x": 160.946
  },
  {
    "y": 155.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1071.54 189.775H1122.67H1129.36V176.698H1142.36V120.883H1071.54V189.775Z",
      "M1132.51 179.883L1132.5 189.892H1135.87V191.285H1139.09V188.068H1142.35V179.883H1132.51Z",
      "M1071.53 189.889H1129.28V176.703H1142.29V120.727H1145.52V185.264H1142.31V188.248H1139.09V185.031H1142.29V179.92H1132.5V189.889H1135.87V193.105H1068.31V120.727H1071.53V189.889ZM1139.09 191.541H1135.87V188.324H1139.09V191.541ZM1145.52 120.725H1068.32V117.508H1145.52V120.725Z"
    ],
    "x": 1106.9499999999998
  },
  {
    "y": 262.59799999999996,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M847.807 297.044H898.945H905.633V283.968H918.629V228.152H847.807V297.044Z",
      "M908.782 287.152L908.768 297.162H912.145V298.554H915.362V295.337H918.624V287.152H908.782Z",
      "M847.804 297.158H905.55V283.973H918.559V227.996H921.795V292.533H918.577V295.518H915.36V292.301H918.559V287.189H908.767V297.158H912.144V300.375H844.586V227.996H847.804V297.158ZM915.361 298.811H912.145V295.594H915.361V298.811ZM921.795 227.994H844.587V224.777H921.795V227.994Z"
    ],
    "x": 883.2180000000001
  },
  {
    "y": 309.32899999999995,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M752.535 343.775H803.674H810.361V330.698H823.357V274.883H752.535V343.775Z",
      "M813.511 333.883L813.496 343.892H816.874V345.285H820.091V342.068H823.353V333.883H813.511Z",
      "M752.532 343.889H810.278V330.703H823.287V274.727H826.523V339.264H823.306V342.248H820.089V339.031H823.287V333.92H813.495V343.889H816.872V347.105H749.314V274.727H752.532V343.889ZM820.09 345.541H816.873V342.324H820.09V345.541ZM826.523 274.725H749.315V271.508H826.523V274.725Z"
    ],
    "x": 787.9459999999999
  },
  {
    "y": 320.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1088.04 354.775H1139.17H1145.86V341.698H1158.86V285.883H1088.04V354.775Z",
      "M1149.01 344.883L1149 354.892H1152.37V356.285H1155.59V353.068H1158.85V344.883H1149.01Z",
      "M1088.03 354.889H1145.78V341.703H1158.79V285.727H1162.02V350.264H1158.81V353.248H1155.59V350.031H1158.79V344.92H1149V354.889H1152.37V358.105H1084.81V285.727H1088.03V354.889ZM1155.59 356.541H1152.37V353.324H1155.59V356.541ZM1162.02 285.725H1084.82V282.508H1162.02V285.725Z"
    ],
    "x": 1123.4499999999998
  },
  {
    "y": 342.32899999999995,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M791.035 376.775H842.174H848.861V363.698H861.857V307.883H791.035V376.775Z",
      "M852.011 366.883L851.996 376.892H855.374V378.285H858.591V375.068H861.853V366.883H852.011Z",
      "M791.032 376.889H848.778V363.703H861.787V307.727H865.023V372.264H861.806V375.248H858.589V372.031H861.787V366.92H851.995V376.889H855.372V380.105H787.814V307.727H791.032V376.889ZM858.59 378.541H855.373V375.324H858.59V378.541ZM865.023 307.725H787.815V304.508H865.023V307.725Z"
    ],
    "x": 826.4459999999999
  },
  {
    "y": 342.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M879.035 376.775H930.174H936.861V363.698H949.857V307.883H879.035V376.775Z",
      "M940.011 366.883L939.996 376.892H943.374V378.285H946.591V375.068H949.853V366.883H940.011Z",
      "M879.032 376.889H936.778V363.703H949.787V307.727H953.023V372.264H949.806V375.248H946.589V372.031H949.787V366.92H939.995V376.889H943.372V380.105H875.814V307.727H879.032V376.889ZM946.59 378.541H943.373V375.324H946.59V378.541ZM953.023 307.725H875.815V304.508H953.023V307.725Z"
    ],
    "x": 914.4459999999999
  },
  {
    "y": 342.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1000.04 376.775H1051.17H1057.86V363.698H1070.86V307.883H1000.04V376.775Z",
      "M1061.01 366.883L1061 376.892H1064.37V378.285H1067.59V375.068H1070.85V366.883H1061.01Z",
      "M1000.03 376.889H1057.78V363.703H1070.79V307.727H1074.02V372.264H1070.81V375.248H1067.59V372.031H1070.79V366.92H1061V376.889H1064.37V380.105H996.814V307.727H1000.03V376.889ZM1067.59 378.541H1064.37V375.324H1067.59V378.541ZM1074.02 307.725H996.815V304.508H1074.02V307.725Z"
    ],
    "x": 1035.4499999999998
  },
  {
    "y": 364.32899999999995,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1176.04 398.775H1227.17H1233.86V385.698H1246.86V329.883H1176.04V398.775Z",
      "M1237.01 388.883L1237 398.892H1240.37V400.285H1243.59V397.068H1246.85V388.883H1237.01Z",
      "M1176.03 398.889H1233.78V385.703H1246.79V329.727H1250.02V394.264H1246.81V397.248H1243.59V394.031H1246.79V388.92H1237V398.889H1240.37V402.105H1172.81V329.727H1176.03V398.889ZM1243.59 400.541H1240.37V397.324H1243.59V400.541ZM1250.02 329.725H1172.82V326.508H1250.02V329.725Z"
    ],
    "x": 1211.4499999999998
  },
  {
    "y": 402.59799999999996,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M853.807 437.044H904.945H911.633V423.968H924.629V368.152H853.807V437.044Z",
      "M914.782 427.152L914.768 437.162H918.145V438.554H921.362V435.337H924.624V427.152H914.782Z",
      "M853.804 437.158H911.55V423.973H924.559V367.996H927.795V432.533H924.577V435.518H921.36V432.301H924.559V427.189H914.767V437.158H918.144V440.375H850.586V367.996H853.804V437.158ZM921.361 438.811H918.145V435.594H921.361V438.811ZM927.795 367.994H850.587V364.777H927.795V367.994Z"
    ],
    "x": 889.2180000000001
  },
  {
    "y": 408.59799999999996,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1030.81 443.044H1081.95H1088.63V429.968H1101.63V374.152H1030.81V443.044Z",
      "M1091.78 433.152L1091.77 443.162H1095.15V444.554H1098.36V441.337H1101.62V433.152H1091.78Z",
      "M1030.8 443.158H1088.55V429.973H1101.56V373.996H1104.79V438.533H1101.58V441.518H1098.36V438.301H1101.56V433.189H1091.77V443.158H1095.14V446.375H1027.59V373.996H1030.8V443.158ZM1098.36 444.811H1095.14V441.594H1098.36V444.811ZM1104.79 373.994H1027.59V370.777H1104.79V373.994Z"
    ],
    "x": 1066.22
  },
  {
    "y": 430.32899999999995,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M1678.04 464.775H1729.17H1735.86V451.698H1748.86V395.883H1678.04V464.775Z",
      "M1739.01 454.883L1739 464.892H1742.37V466.285H1745.59V463.068H1748.85V454.883H1739.01Z",
      "M1678.03 464.889H1735.78V451.703H1748.79V395.727H1752.02V460.264H1748.81V463.248H1745.59V460.031H1748.79V454.92H1739V464.889H1742.37V468.105H1674.81V395.727H1678.03V464.889ZM1745.59 466.541H1742.37V463.324H1745.59V466.541ZM1752.02 395.725H1674.82V392.508H1752.02V395.725Z"
    ],
    "x": 1713.4499999999998
  },
  {
    "y": 494.32899999999995,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M917.535 528.775H968.674H975.361V515.698H988.357V459.883H917.535V528.775Z",
      "M978.511 518.883L978.496 528.892H981.874V530.285H985.091V527.068H988.353V518.883H978.511Z",
      "M917.532 528.889H975.278V515.703H988.287V459.727H991.523V524.264H988.306V527.248H985.089V524.031H988.287V518.92H978.495V528.889H981.872V532.105H914.314V459.727H917.532V528.889ZM985.09 530.541H981.873V527.324H985.09V530.541ZM991.523 459.725H914.315V456.508H991.523V459.725Z"
    ],
    "x": 952.9459999999999
  },
  {
    "y": 507.32899999999995,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M1521.54 541.775H1572.67H1579.36V528.698H1592.36V472.883H1521.54V541.775Z",
      "M1582.51 531.883L1582.5 541.892H1585.87V543.285H1589.09V540.068H1592.35V531.883H1582.51Z",
      "M1521.53 541.889H1579.28V528.703H1592.29V472.727H1595.52V537.264H1592.31V540.248H1589.09V537.031H1592.29V531.92H1582.5V541.889H1585.87V545.105H1518.31V472.727H1521.53V541.889ZM1589.09 543.541H1585.87V540.324H1589.09V543.541ZM1595.52 472.725H1518.32V469.508H1595.52V472.725Z"
    ],
    "x": 1556.9499999999998
  },
  {
    "y": 518.329,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1363.04 552.775H1414.17H1420.86V539.698H1433.86V483.883H1363.04V552.775Z",
      "M1424.01 542.883L1424 552.892H1427.37V554.285H1430.59V551.068H1433.85V542.883H1424.01Z",
      "M1363.03 552.889H1420.78V539.703H1433.79V483.727H1437.02V548.264H1433.81V551.248H1430.59V548.031H1433.79V542.92H1424V552.889H1427.37V556.105H1359.81V483.727H1363.03V552.889ZM1430.59 554.541H1427.37V551.324H1430.59V554.541ZM1437.02 483.725H1359.82V480.508H1437.02V483.725Z"
    ],
    "x": 1398.4499999999998
  },
  {
    "y": 529.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1005.54 563.775H1056.67H1063.36V550.698H1076.36V494.883H1005.54V563.775Z",
      "M1066.51 553.883L1066.5 563.892H1069.87V565.285H1073.09V562.068H1076.35V553.883H1066.51Z",
      "M1005.53 563.889H1063.28V550.703H1076.29V494.727H1079.52V559.264H1076.31V562.248H1073.09V559.031H1076.29V553.92H1066.5V563.889H1069.87V567.105H1002.31V494.727H1005.53V563.889ZM1073.09 565.541H1069.87V562.324H1073.09V565.541ZM1079.52 494.725H1002.32V491.508H1079.52V494.725Z"
    ],
    "x": 1040.9499999999998
  },
  {
    "y": 551.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M686.535 585.775H737.674H744.361V572.698H757.357V516.883H686.535V585.775Z",
      "M747.511 575.883L747.496 585.892H750.874V587.285H754.091V584.068H757.353V575.883H747.511Z",
      "M686.532 585.889H744.278V572.703H757.287V516.727H760.523V581.264H757.306V584.248H754.089V581.031H757.287V575.92H747.495V585.889H750.872V589.105H683.314V516.727H686.532V585.889ZM754.09 587.541H750.873V584.324H754.09V587.541ZM760.523 516.725H683.315V513.508H760.523V516.725Z"
    ],
    "x": 721.9459999999999
  },
  {
    "y": 573.329,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M961.535 607.775H1012.67H1019.36V594.698H1032.36V538.883H961.535V607.775Z",
      "M1022.51 597.883L1022.5 607.892H1025.87V609.285H1029.09V606.068H1032.35V597.883H1022.51Z",
      "M961.532 607.889H1019.28V594.703H1032.29V538.727H1035.52V603.264H1032.31V606.248H1029.09V603.031H1032.29V597.92H1022.5V607.889H1025.87V611.105H958.314V538.727H961.532V607.889ZM1029.09 609.541H1025.87V606.324H1029.09V609.541ZM1035.52 538.725H958.315V535.508H1035.52V538.725Z"
    ],
    "x": 996.9475
  },
  {
    "y": 585.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M149.035 619.775H200.174H206.861V606.698H219.857V550.883H149.035V619.775Z",
      "M210.011 609.883L209.996 619.892H213.374V621.285H216.591V618.068H219.853V609.883H210.011Z",
      "M149.032 619.889H206.778V606.703H219.787V550.727H223.023V615.264H219.806V618.248H216.589V615.031H219.787V609.92H209.995V619.889H213.372V623.105H145.814V550.727H149.032V619.889ZM216.59 621.541H213.373V618.324H216.59V621.541ZM223.023 550.725H145.815V547.508H223.023V550.725Z"
    ],
    "x": 184.446
  },
  {
    "y": 606.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1632.54 640.775H1683.67H1690.36V627.698H1703.36V571.883H1632.54V640.775Z",
      "M1693.51 630.883L1693.5 640.892H1696.87V642.285H1700.09V639.068H1703.35V630.883H1693.51Z",
      "M1632.53 640.889H1690.28V627.703H1703.29V571.727H1706.52V636.264H1703.31V639.248H1700.09V636.031H1703.29V630.92H1693.5V640.889H1696.87V644.105H1629.31V571.727H1632.53V640.889ZM1700.09 642.541H1696.87V639.324H1700.09V642.541ZM1706.52 571.725H1629.32V568.508H1706.52V571.725Z"
    ],
    "x": 1667.9499999999998
  },
  {
    "y": 628.329,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1220.04 662.775H1271.17H1277.86V649.698H1290.86V593.883H1220.04V662.775Z",
      "M1281.01 652.883L1281 662.892H1284.37V664.285H1287.59V661.068H1290.85V652.883H1281.01Z",
      "M1220.03 662.889H1277.78V649.703H1290.79V593.727H1294.02V658.264H1290.81V661.248H1287.59V658.031H1290.79V652.92H1281V662.889H1284.37V666.105H1216.81V593.727H1220.03V662.889ZM1287.59 664.541H1284.37V661.324H1287.59V664.541ZM1294.02 593.725H1216.82V590.508H1294.02V593.725Z"
    ],
    "x": 1255.4499999999998
  },
  {
    "y": 682.598,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1092.81 717.044H1143.95H1150.63V703.968H1163.63V648.152H1092.81V717.044Z",
      "M1153.78 707.152L1153.77 717.162H1157.15V718.554H1160.36V715.337H1163.62V707.152H1153.78Z",
      "M1092.8 717.158H1150.55V703.973H1163.56V647.996H1166.79V712.533H1163.58V715.518H1160.36V712.301H1163.56V707.189H1153.77V717.158H1157.14V720.375H1089.59V647.996H1092.8V717.158ZM1160.36 718.811H1157.14V715.594H1160.36V718.811ZM1166.79 647.994H1089.59V644.777H1166.79V647.994Z"
    ],
    "x": 1128.22
  },
  {
    "y": 694.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M1242.04 728.775H1293.17H1299.86V715.698H1312.86V659.883H1242.04V728.775Z",
      "M1303.01 718.883L1303 728.892H1306.37V730.285H1309.59V727.068H1312.85V718.883H1303.01Z",
      "M1242.03 728.889H1299.78V715.703H1312.79V659.727H1316.02V724.264H1312.81V727.248H1309.59V724.031H1312.79V718.92H1303V728.889H1306.37V732.105H1238.81V659.727H1242.03V728.889ZM1309.59 730.541H1306.37V727.324H1309.59V730.541ZM1316.02 659.725H1238.82V656.508H1316.02V659.725Z"
    ],
    "x": 1277.4499999999998
  },
  {
    "y": 694.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1344.04 728.775H1395.17H1401.86V715.698H1414.86V659.883H1344.04V728.775Z",
      "M1405.01 718.883L1405 728.892H1408.37V730.285H1411.59V727.068H1414.85V718.883H1405.01Z",
      "M1344.03 728.889H1401.78V715.703H1414.79V659.727H1418.02V724.264H1414.81V727.248H1411.59V724.031H1414.79V718.92H1405V728.889H1408.37V732.105H1340.81V659.727H1344.03V728.889ZM1411.59 730.541H1408.37V727.324H1411.59V730.541ZM1418.02 659.725H1340.82V656.508H1418.02V659.725Z"
    ],
    "x": 1379.4499999999998
  },
  {
    "y": 210.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1594.04 244.775H1645.17H1651.86V231.698H1664.86V175.883H1594.04V244.775Z",
      "M1655.01 234.883L1655 244.892H1658.37V246.285H1661.59V243.068H1664.85V234.883H1655.01Z",
      "M1594.03 244.889H1651.78V231.703H1664.79V175.727H1668.02V240.264H1664.81V243.248H1661.59V240.031H1664.79V234.92H1655V244.889H1658.37V248.105H1590.81V175.727H1594.03V244.889ZM1661.59 246.541H1658.37V243.324H1661.59V246.541ZM1668.02 175.725H1590.82V172.508H1668.02V175.725Z"
    ],
    "x": 1629.4499999999998
  },
  {
    "y": 694.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1022.04 728.775H1073.17H1079.86V715.698H1092.86V659.883H1022.04V728.775Z",
      "M1083.01 718.883L1083 728.892H1086.37V730.285H1089.59V727.068H1092.85V718.883H1083.01Z",
      "M1022.03 728.889H1079.78V715.703H1092.79V659.727H1096.02V724.264H1092.81V727.248H1089.59V724.031H1092.79V718.92H1083V728.889H1086.37V732.105H1018.81V659.727H1022.03V728.889ZM1089.59 730.541H1086.37V727.324H1089.59V730.541ZM1096.02 659.725H1018.82V656.508H1096.02V659.725Z"
    ],
    "x": 1057.4499999999998
  },
  {
    "y": 511.59799999999996,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M89.8066 546.044H140.945H147.633V532.968H160.629V477.152H89.8066V546.044Z",
      "M150.782 536.152L150.768 546.162H154.145V547.554H157.362V544.337H160.624V536.152H150.782Z",
      "M89.8037 546.158H147.55V532.973H160.559V476.996H163.795V541.533H160.577V544.518H157.36V541.301H160.559V536.189H150.767V546.158H154.144V549.375H86.5859V476.996H89.8037V546.158ZM157.361 547.811H154.145V544.594H157.361V547.811ZM163.795 476.994H86.5869V473.777H163.795V476.994Z"
    ],
    "x": 125.2178
  },
  {
    "y": 705.329,
    "color": "#F3BDD5",
    "foldColor": "#CF6393",
    "paths": [
      "M752.535 739.775H803.674H810.361V726.698H823.357V670.883H752.535V739.775Z",
      "M813.511 729.883L813.496 739.892H816.874V741.285H820.091V738.068H823.353V729.883H813.511Z",
      "M752.532 739.889H810.278V726.703H823.287V670.727H826.523V735.264H823.306V738.248H820.089V735.031H823.287V729.92H813.495V739.889H816.872V743.105H749.314V670.727H752.532V739.889ZM820.09 741.541H816.873V738.324H820.09V741.541ZM826.523 670.725H749.315V667.508H826.523V670.725Z"
    ],
    "x": 787.9459999999999
  },
  {
    "y": 221.329,
    "color": "#BDFAA7",
    "foldColor": "#7AB460",
    "paths": [
      "M972.535 255.775H1023.67H1030.36V242.698H1043.36V186.883H972.535V255.775Z",
      "M1033.51 245.883L1033.5 255.892H1036.87V257.285H1040.09V254.068H1043.35V245.883H1033.51Z",
      "M972.532 255.889H1030.28V242.703H1043.29V186.727H1046.52V251.264H1043.31V254.248H1040.09V251.031H1043.29V245.92H1033.5V255.889H1036.87V259.105H969.314V186.727H972.532V255.889ZM1040.09 257.541H1036.87V254.324H1040.09V257.541ZM1046.52 186.725H969.315V183.508H1046.52V186.725Z"
    ],
    "x": 1007.9475
  },
  {
    "y": 243.329,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1038.54 277.775H1089.67H1096.36V264.698H1109.36V208.883H1038.54V277.775Z",
      "M1099.51 267.883L1099.5 277.892H1102.87V279.285H1106.09V276.068H1109.35V267.883H1099.51Z",
      "M1038.53 277.889H1096.28V264.703H1109.29V208.727H1112.52V273.264H1109.31V276.248H1106.09V273.031H1109.29V267.92H1099.5V277.889H1102.87V281.105H1035.31V208.727H1038.53V277.889ZM1106.09 279.541H1102.87V276.324H1106.09V279.541ZM1112.52 208.725H1035.32V205.508H1112.52V208.725Z"
    ],
    "x": 1073.9499999999998
  },
  {
    "y": 452.32899999999995,
    "color": "#BEDEFF",
    "foldColor": "#4489D0",
    "paths": [
      "M1256.04 486.775H1307.17H1313.86V473.698H1326.86V417.883H1256.04V486.775Z",
      "M1317.01 476.883L1317 486.892H1320.37V488.285H1323.59V485.068H1326.85V476.883H1317.01Z",
      "M1256.03 486.889H1313.78V473.703H1326.79V417.727H1330.02V482.264H1326.81V485.248H1323.59V482.031H1326.79V476.92H1317V486.889H1320.37V490.105H1252.81V417.727H1256.03V486.889ZM1323.59 488.541H1320.37V485.324H1323.59V488.541ZM1330.02 417.725H1252.82V414.508H1330.02V417.725Z"
    ],
    "x": 1291.4499999999998
  },
  {
    "y": 580.8050000000001,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M1769.31 615.251H1820.45H1827.13V602.175H1840.13V546.359H1769.31V615.251Z",
      "M1830.28 605.359L1830.27 615.369H1833.65V616.762H1836.86V613.545H1840.12V605.359H1830.28Z",
      "M1769.3 615.365H1827.05V602.18H1840.06V546.203H1843.29V610.74H1840.08V613.725H1836.86V610.508H1840.06V605.396H1830.27V615.365H1833.64V618.582H1766.09V546.203H1769.3V615.365ZM1836.86 617.018H1833.64V613.801H1836.86V617.018ZM1843.29 546.201H1766.09V542.984H1843.29V546.201Z"
    ],
    "x": 1804.72
  },
  {
    "y": 397.32899999999995,
    "color": "#FFEB48",
    "foldColor": "#D0C145",
    "paths": [
      "M983.535 431.775H1034.67H1041.36V418.698H1054.36V362.883H983.535V431.775Z",
      "M1044.51 421.883L1044.5 431.892H1047.87V433.285H1051.09V430.068H1054.35V421.883H1044.51Z",
      "M983.532 431.889H1041.28V418.703H1054.29V362.727H1057.52V427.264H1054.31V430.248H1051.09V427.031H1054.29V421.92H1044.5V431.889H1047.87V435.105H980.314V362.727H983.532V431.889ZM1051.09 433.541H1047.87V430.324H1051.09V433.541ZM1057.52 362.725H980.315V359.508H1057.52V362.725Z"
    ],
    "x": 1018.9475
  },
  {
    "y": 546.598,
    "color": "#FFB042",
    "foldColor": "#B47B2D",
    "paths": [
      "M122.807 581.044H173.945H180.633V567.968H193.629V512.152H122.807V581.044Z",
      "M183.782 571.152L183.768 581.162H187.145V582.554H190.362V579.337H193.624V571.152H183.782Z",
      "M122.804 581.158H180.55V567.973H193.559V511.996H196.795V576.533H193.577V579.518H190.36V576.301H193.559V571.189H183.767V581.158H187.144V584.375H119.586V511.996H122.804V581.158ZM190.361 582.811H187.145V579.594H190.361V582.811ZM196.795 511.994H119.587V508.777H196.795V511.994Z"
    ],
    "x": 158.218
  }
]);
